/* tslint:disable */
/* eslint-disable */
/**
 * ATV Wizard API
 * ATV Wizard API
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ATVOCRPresetDTO
 */
export interface ATVOCRPresetDTO {
    /**
     * 
     * @type {number}
     * @memberof ATVOCRPresetDTO
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ATVOCRPresetDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface AudioSettings
 */
export interface AudioSettings {
    /**
     * 
     * @type {number}
     * @memberof AudioSettings
     */
    'balance': number;
    /**
     * 
     * @type {boolean}
     * @memberof AudioSettings
     */
    'enabled': boolean;
}
/**
 * 
 * @export
 * @interface BaseDevicePresetProDTO
 */
export interface BaseDevicePresetProDTO {
    /**
     * 
     * @type {number}
     * @memberof BaseDevicePresetProDTO
     */
    'atv_ocr_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof BaseDevicePresetProDTO
     */
    'default_ocr_files'?: Array<number>;
    /**
     * 
     * @type {boolean}
     * @memberof BaseDevicePresetProDTO
     */
    'favorited'?: boolean;
    /**
     * 
     * @type {GraphicsEngineEnum}
     * @memberof BaseDevicePresetProDTO
     */
    'graphics_engine'?: GraphicsEngineEnum;
    /**
     * 
     * @type {ManualScorebugConfigurationDTO}
     * @memberof BaseDevicePresetProDTO
     */
    'manual_scorebug_configuration'?: ManualScorebugConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof BaseDevicePresetProDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof BaseDevicePresetProDTO
     */
    'num_periods'?: number;
    /**
     * 
     * @type {ProOverlayDTO}
     * @memberof BaseDevicePresetProDTO
     */
    'overlays'?: ProOverlayDTO;
    /**
     * 
     * @type {string}
     * @memberof BaseDevicePresetProDTO
     */
    'period_duration'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof BaseDevicePresetProDTO
     */
    'shared_with_fields'?: Array<string>;
    /**
     * 
     * @type {SportResponseDTO}
     * @memberof BaseDevicePresetProDTO
     */
    'sport': SportResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof BaseDevicePresetProDTO
     */
    'uuid': string;
}


/**
 * 
 * @export
 * @interface CalibrationBaseDTO
 */
export interface CalibrationBaseDTO {
    /**
     * 
     * @type {number}
     * @memberof CalibrationBaseDTO
     */
    'length': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationBaseDTO
     */
    'width': number;
}
/**
 * 
 * @export
 * @interface CalibrationDTO
 */
export interface CalibrationDTO {
    /**
     * 
     * @type {{ [key: string]: CameraOptionsCalibrationDTO; }}
     * @memberof CalibrationDTO
     */
    'cameras_calibrations': { [key: string]: CameraOptionsCalibrationDTO; };
    /**
     * 
     * @type {number}
     * @memberof CalibrationDTO
     */
    'length': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationDTO
     */
    'width': number;
}
/**
 * 
 * @export
 * @interface CalibrationLineDTO
 */
export interface CalibrationLineDTO {
    /**
     * 
     * @type {DirectionEnum}
     * @memberof CalibrationLineDTO
     */
    'direction'?: DirectionEnum;
    /**
     * 
     * @type {number}
     * @memberof CalibrationLineDTO
     */
    'id': number;
    /**
     * 
     * @type {Array<OptIdPointDTO>}
     * @memberof CalibrationLineDTO
     */
    'points': Array<OptIdPointDTO>;
}


/**
 * 
 * @export
 * @interface CalibrationOptionsDTO
 */
export interface CalibrationOptionsDTO {
    /**
     * 
     * @type {{ [key: string]: CameraOptionsCalibrationDTO; }}
     * @memberof CalibrationOptionsDTO
     */
    'cameras_calibrations': { [key: string]: CameraOptionsCalibrationDTO; };
    /**
     * 
     * @type {Image}
     * @memberof CalibrationOptionsDTO
     */
    'field': Image;
    /**
     * 
     * @type {number}
     * @memberof CalibrationOptionsDTO
     */
    'length': number;
    /**
     * 
     * @type {number}
     * @memberof CalibrationOptionsDTO
     */
    'width': number;
}
/**
 * 
 * @export
 * @interface Camera
 */
export interface Camera {
}
/**
 * 
 * @export
 * @interface CameraCalibrationDTO
 */
export interface CameraCalibrationDTO {
    /**
     * 
     * @type {number}
     * @memberof CameraCalibrationDTO
     */
    'camera_id': number;
    /**
     * 
     * @type {string}
     * @memberof CameraCalibrationDTO
     */
    'camera_name': string;
    /**
     * 
     * @type {Image}
     * @memberof CameraCalibrationDTO
     */
    'field'?: Image;
    /**
     * 
     * @type {Image}
     * @memberof CameraCalibrationDTO
     */
    'image': Image;
    /**
     * 
     * @type {Array<CalibrationLineDTO>}
     * @memberof CameraCalibrationDTO
     */
    'lines'?: Array<CalibrationLineDTO>;
    /**
     * 
     * @type {Array<IdPointDTO>}
     * @memberof CameraCalibrationDTO
     */
    'points'?: Array<IdPointDTO>;
}
/**
 * 
 * @export
 * @interface CameraDTO
 */
export interface CameraDTO {
    /**
     * 
     * @type {boolean}
     * @memberof CameraDTO
     */
    'active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CameraDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof CameraDTO
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof CameraDTO
     */
    'uri'?: string;
    /**
     * 
     * @type {string}
     * @memberof CameraDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const CameraNameEnum = {
    Camera: 'camera',
    CameraLeft: 'camera_left',
    CameraCenterleft: 'camera_centerleft',
    CameraCenterright: 'camera_centerright',
    CameraRight: 'camera_right'
} as const;

export type CameraNameEnum = typeof CameraNameEnum[keyof typeof CameraNameEnum];


/**
 * 
 * @export
 * @interface CameraOptionsCalibrationDTO
 */
export interface CameraOptionsCalibrationDTO {
    /**
     * 
     * @type {number}
     * @memberof CameraOptionsCalibrationDTO
     */
    'camera_id': number;
    /**
     * 
     * @type {string}
     * @memberof CameraOptionsCalibrationDTO
     */
    'camera_name': string;
    /**
     * 
     * @type {Array<CalibrationLineDTO>}
     * @memberof CameraOptionsCalibrationDTO
     */
    'lines'?: Array<CalibrationLineDTO>;
    /**
     * 
     * @type {Array<IdPointDTO>}
     * @memberof CameraOptionsCalibrationDTO
     */
    'points'?: Array<IdPointDTO>;
}
/**
 * 
 * @export
 * @interface ChangeSetting
 */
export interface ChangeSetting {
    /**
     * 
     * @type {string}
     * @memberof ChangeSetting
     */
    'name': string;
    /**
     * 
     * @type {Value}
     * @memberof ChangeSetting
     */
    'value': Value;
}
/**
 * 
 * @export
 * @interface CommonValueDisplayNameDTOPresetModeEnum
 */
export interface CommonValueDisplayNameDTOPresetModeEnum {
    /**
     * 
     * @type {string}
     * @memberof CommonValueDisplayNameDTOPresetModeEnum
     */
    'display_name': string;
    /**
     * 
     * @type {PresetModeEnum}
     * @memberof CommonValueDisplayNameDTOPresetModeEnum
     */
    'value': PresetModeEnum;
}


/**
 * 
 * @export
 * @interface CommonValueDisplayNameDTOPresetStrategyEnum
 */
export interface CommonValueDisplayNameDTOPresetStrategyEnum {
    /**
     * 
     * @type {string}
     * @memberof CommonValueDisplayNameDTOPresetStrategyEnum
     */
    'display_name': string;
    /**
     * 
     * @type {PresetStrategyEnum}
     * @memberof CommonValueDisplayNameDTOPresetStrategyEnum
     */
    'value': PresetStrategyEnum;
}


/**
 * 
 * @export
 * @interface DefaultResponseDTO
 */
export interface DefaultResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof DefaultResponseDTO
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DefaultResponseDTO1
 */
export interface DefaultResponseDTO1 {
    /**
     * 
     * @type {number}
     * @memberof DefaultResponseDTO1
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO1
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface DefaultResponseDTO2
 */
export interface DefaultResponseDTO2 {
    /**
     * 
     * @type {number}
     * @memberof DefaultResponseDTO2
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof DefaultResponseDTO2
     */
    'message': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeployActionEnum = {
    Install: 'install',
    Uninstall: 'uninstall',
    Upgrade: 'upgrade'
} as const;

export type DeployActionEnum = typeof DeployActionEnum[keyof typeof DeployActionEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const DeployStatusEnum = {
    Creating: 'creating',
    Initializing: 'initializing',
    InProgress: 'in_progress',
    AlreadyRunning: 'already_running',
    Succeed: 'succeed',
    Failed: 'failed'
} as const;

export type DeployStatusEnum = typeof DeployStatusEnum[keyof typeof DeployStatusEnum];


/**
 * 
 * @export
 * @interface DeploymentDTO
 */
export interface DeploymentDTO {
    /**
     * 
     * @type {DeployActionEnum}
     * @memberof DeploymentDTO
     */
    'action': DeployActionEnum;
    /**
     * 
     * @type {DeployStatusEnum}
     * @memberof DeploymentDTO
     */
    'status': DeployStatusEnum;
    /**
     * 
     * @type {VersionDTO}
     * @memberof DeploymentDTO
     */
    'version': VersionDTO;
}


/**
 * 
 * @export
 * @interface DestinationsInfoDTO
 */
export interface DestinationsInfoDTO {
    /**
     * 
     * @type {Array<PresetDestinationDTO>}
     * @memberof DestinationsInfoDTO
     */
    'destinations'?: Array<PresetDestinationDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof DestinationsInfoDTO
     */
    'panorama_enabled'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DestinationsInfoDTO
     */
    'quality': string;
}
/**
 * 
 * @export
 * @interface DeviceATVOCRPresetOptions
 */
export interface DeviceATVOCRPresetOptions {
    /**
     * 
     * @type {string}
     * @memberof DeviceATVOCRPresetOptions
     */
    'display_name': string;
    /**
     * 
     * @type {number}
     * @memberof DeviceATVOCRPresetOptions
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface DeviceDTO
 */
export interface DeviceDTO {
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDTO
     */
    'is_configured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDTO
     */
    'is_installed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDTO
     */
    'is_licensed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDTO
     */
    'is_recording'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceDTO
     */
    'is_registered'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DeviceDTO
     */
    'name': string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof DeviceDTO
     */
    'organization': OrganizationDTO;
    /**
     * 
     * @type {ProducerDTO}
     * @memberof DeviceDTO
     */
    'producer': ProducerDTO;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof DeviceDTO
     */
    'software_failed'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {Array<SoftwareInstalledDTO>}
     * @memberof DeviceDTO
     */
    'software_installed'?: Array<SoftwareInstalledDTO>;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof DeviceDTO
     */
    'software_installing'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {DeviceStatusEnum}
     * @memberof DeviceDTO
     */
    'status'?: DeviceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceDTO
     */
    'uuid'?: string;
}


/**
 * 
 * @export
 * @interface DeviceDeploymentDTO
 */
export interface DeviceDeploymentDTO {
    /**
     * 
     * @type {DeployActionEnum}
     * @memberof DeviceDeploymentDTO
     */
    'action': DeployActionEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceDeploymentDTO
     */
    'device_uuid'?: string;
    /**
     * 
     * @type {DeployStatusEnum}
     * @memberof DeviceDeploymentDTO
     */
    'status': DeployStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceDeploymentDTO
     */
    'uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceDeploymentDTO
     */
    'version_number'?: string;
}


/**
 * DTO based on the first step of a field configuration
 * @export
 * @interface DeviceDetailsDTO
 */
export interface DeviceDetailsDTO {
    /**
     * 
     * @type {EnclosureTypeEnum}
     * @memberof DeviceDetailsDTO
     */
    'enclosure_type'?: EnclosureTypeEnum;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof DeviceDetailsDTO
     */
    'field_type'?: FieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailsDTO
     */
    'name': string;
    /**
     * 
     * @type {TimeZonesEnum}
     * @memberof DeviceDetailsDTO
     */
    'timezone': TimeZonesEnum;
}


/**
 * 
 * @export
 * @interface DeviceDetailsProDTO
 */
export interface DeviceDetailsProDTO {
    /**
     * 
     * @type {string}
     * @memberof DeviceDetailsProDTO
     */
    'name': string;
    /**
     * 
     * @type {TimeZonesEnum}
     * @memberof DeviceDetailsProDTO
     */
    'timezone': TimeZonesEnum;
}


/**
 * 
 * @export
 * @interface DeviceOCRFilesOptions
 */
export interface DeviceOCRFilesOptions {
    /**
     * 
     * @type {string}
     * @memberof DeviceOCRFilesOptions
     */
    'display_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceOCRFilesOptions
     */
    'is_default'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof DeviceOCRFilesOptions
     */
    'value': number;
}
/**
 * 
 * @export
 * @interface DeviceOCROptions
 */
export interface DeviceOCROptions {
    /**
     * 
     * @type {Array<DeviceATVOCRPresetOptions>}
     * @memberof DeviceOCROptions
     */
    'atv_ocr_presets'?: Array<DeviceATVOCRPresetOptions>;
    /**
     * 
     * @type {Array<DeviceOCRFilesOptions>}
     * @memberof DeviceOCROptions
     */
    'ocr_files'?: Array<DeviceOCRFilesOptions>;
}
/**
 * Main DTO to get all the information about a device
 * @export
 * @interface DeviceProConfigurationDTO
 */
export interface DeviceProConfigurationDTO {
    /**
     * 
     * @type {DeviceDetailsProDTO}
     * @memberof DeviceProConfigurationDTO
     */
    'details'?: DeviceDetailsProDTO;
    /**
     * 
     * @type {string}
     * @memberof DeviceProConfigurationDTO
     */
    'device_uuid': string;
    /**
     * 
     * @type {ResponseDeviceScoreboardDTO}
     * @memberof DeviceProConfigurationDTO
     */
    'scoreboard_configuration'?: ResponseDeviceScoreboardDTO;
}
/**
 * 
 * @export
 * @interface DeviceRegisterDTO
 */
export interface DeviceRegisterDTO {
    /**
     * 
     * @type {string}
     * @memberof DeviceRegisterDTO
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegisterDTO
     */
    'serial_number_producer': string;
}
/**
 * 
 * @export
 * @interface DeviceRegisterResponseDTO
 */
export interface DeviceRegisterResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof DeviceRegisterResponseDTO
     */
    'name': string;
    /**
     * 
     * @type {TimeZonesEnum}
     * @memberof DeviceRegisterResponseDTO
     */
    'timezone': TimeZonesEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceRegisterResponseDTO
     */
    'uuid'?: string;
}


/**
 * DTO based on the third step of a field configuration
 * @export
 * @interface DeviceScoreboardDTO
 */
export interface DeviceScoreboardDTO {
    /**
     * 
     * @type {string}
     * @memberof DeviceScoreboardDTO
     */
    'input_plugin'?: string;
    /**
     * 
     * @type {Array<OcrFilesDTO>}
     * @memberof DeviceScoreboardDTO
     */
    'ocr_files'?: Array<OcrFilesDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceScoreboardDTO
     */
    'ocr_files_to_delete'?: Array<string>;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const DeviceStatusEnum = {
    Unknown: 'unknown',
    Offline: 'offline',
    Unregistered: 'unregistered',
    Unlicensed: 'unlicensed',
    NotInstalled: 'not_installed',
    NotConfigured: 'not_configured',
    Recording: 'recording',
    Ready: 'ready',
    Configuring: 'configuring',
    Upgrading: 'upgrading',
    Installing: 'installing',
    CameraUnavailable: 'camera_unavailable'
} as const;

export type DeviceStatusEnum = typeof DeviceStatusEnum[keyof typeof DeviceStatusEnum];


/**
 * 
 * @export
 * @interface DeviceUUIDsDTO
 */
export interface DeviceUUIDsDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof DeviceUUIDsDTO
     */
    'device_uuids': Array<string>;
}
/**
 * 
 * @export
 * @interface DeviceWithCamerasDTO
 */
export interface DeviceWithCamerasDTO {
    /**
     * 
     * @type {Array<CameraDTO>}
     * @memberof DeviceWithCamerasDTO
     */
    'cameras'?: Array<CameraDTO>;
    /**
     * 
     * @type {EnclosureTypeEnum}
     * @memberof DeviceWithCamerasDTO
     */
    'enclosure_type'?: EnclosureTypeEnum;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof DeviceWithCamerasDTO
     */
    'field_type'?: FieldTypeEnum;
    /**
     * 
     * @type {Array<FieldDTO>}
     * @memberof DeviceWithCamerasDTO
     */
    'fields'?: Array<FieldDTO>;
    /**
     * 
     * @type {FrameRateEnum}
     * @memberof DeviceWithCamerasDTO
     */
    'framerate'?: FrameRateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceWithCamerasDTO
     */
    'is_configured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceWithCamerasDTO
     */
    'is_installed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceWithCamerasDTO
     */
    'is_licensed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceWithCamerasDTO
     */
    'is_recording'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DeviceWithCamerasDTO
     */
    'is_registered'?: boolean;
    /**
     * 
     * @type {LensSizeEnum}
     * @memberof DeviceWithCamerasDTO
     */
    'lens_size'?: LensSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceWithCamerasDTO
     */
    'name': string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof DeviceWithCamerasDTO
     */
    'organization': OrganizationDTO;
    /**
     * 
     * @type {ProducerDTO}
     * @memberof DeviceWithCamerasDTO
     */
    'producer': ProducerDTO;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof DeviceWithCamerasDTO
     */
    'software_failed'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {Array<SoftwareInstalledDTO>}
     * @memberof DeviceWithCamerasDTO
     */
    'software_installed'?: Array<SoftwareInstalledDTO>;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof DeviceWithCamerasDTO
     */
    'software_installing'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {DeviceStatusEnum}
     * @memberof DeviceWithCamerasDTO
     */
    'status'?: DeviceStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof DeviceWithCamerasDTO
     */
    'uuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const DevicesSortOptions = {
    Name: 'name',
    License: 'license',
    OrgName: 'org_name',
    SoftwareInstalled: 'software_installed',
    Status: 'status'
} as const;

export type DevicesSortOptions = typeof DevicesSortOptions[keyof typeof DevicesSortOptions];


/**
 * 
 * @export
 * @enum {string}
 */

export const DirectionEnum = {
    Horizontal: 'horizontal',
    Vertical: 'vertical'
} as const;

export type DirectionEnum = typeof DirectionEnum[keyof typeof DirectionEnum];


/**
 * 
 * @export
 * @interface DuplicatePresetDTO
 */
export interface DuplicatePresetDTO {
    /**
     * 
     * @type {string}
     * @memberof DuplicatePresetDTO
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface EditDeviceDTO
 */
export interface EditDeviceDTO {
    /**
     * 
     * @type {EnclosureTypeEnum}
     * @memberof EditDeviceDTO
     */
    'enclosure_type'?: EnclosureTypeEnum;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof EditDeviceDTO
     */
    'field_type'?: FieldTypeEnum;
    /**
     * 
     * @type {FrameRateEnum}
     * @memberof EditDeviceDTO
     */
    'framerate': FrameRateEnum;
    /**
     * 
     * @type {LensSizeEnum}
     * @memberof EditDeviceDTO
     */
    'lens_size'?: LensSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditDeviceDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof EditDeviceDTO
     */
    'uuid_external_camera'?: string;
}


/**
 * 
 * @export
 * @interface EditDeviceDetailsDTO
 */
export interface EditDeviceDetailsDTO {
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof EditDeviceDetailsDTO
     */
    'field_type'?: FieldTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditDeviceDetailsDTO
     */
    'name': string;
}


/**
 * Main DTO to edit and configure all the information about a device
 * @export
 * @interface EditFieldConfigurationDTO
 */
export interface EditFieldConfigurationDTO {
    /**
     * 
     * @type {Array<SportCalibration>}
     * @memberof EditFieldConfigurationDTO
     */
    'configured_sports'?: Array<SportCalibration>;
    /**
     * 
     * @type {DeviceDetailsDTO}
     * @memberof EditFieldConfigurationDTO
     */
    'details'?: DeviceDetailsDTO;
    /**
     * 
     * @type {DeviceScoreboardDTO}
     * @memberof EditFieldConfigurationDTO
     */
    'scoreboard_configuration'?: DeviceScoreboardDTO;
}
/**
 * 
 * @export
 * @interface EditFieldPresetDTO
 */
export interface EditFieldPresetDTO {
    /**
     * 
     * @type {number}
     * @memberof EditFieldPresetDTO
     */
    'atv_ocr_id'?: number;
    /**
     * 
     * @type {AudioSettings}
     * @memberof EditFieldPresetDTO
     */
    'audio': AudioSettings;
    /**
     * 
     * @type {{ [key: string]: Camera; }}
     * @memberof EditFieldPresetDTO
     */
    'camera': { [key: string]: Camera; };
    /**
     * 
     * @type {Array<number>}
     * @memberof EditFieldPresetDTO
     */
    'default_ocr_files'?: Array<number>;
    /**
     * 
     * @type {DestinationsInfoDTO}
     * @memberof EditFieldPresetDTO
     */
    'destinations_info': DestinationsInfoDTO;
    /**
     * 
     * @type {boolean}
     * @memberof EditFieldPresetDTO
     */
    'favorited'?: boolean;
    /**
     * 
     * @type {GraphicsEngineEnum}
     * @memberof EditFieldPresetDTO
     */
    'graphics_engine'?: GraphicsEngineEnum;
    /**
     * 
     * @type {ManualScorebugConfigurationDTO}
     * @memberof EditFieldPresetDTO
     */
    'manual_scorebug_configuration'?: ManualScorebugConfigurationDTO;
    /**
     * 
     * @type {CommonValueDisplayNameDTOPresetModeEnum}
     * @memberof EditFieldPresetDTO
     */
    'mode': CommonValueDisplayNameDTOPresetModeEnum;
    /**
     * 
     * @type {string}
     * @memberof EditFieldPresetDTO
     */
    'name': string;
    /**
     * 
     * @type {NumPeriods}
     * @memberof EditFieldPresetDTO
     */
    'num_periods'?: NumPeriods;
    /**
     * 
     * @type {OverlayDTO}
     * @memberof EditFieldPresetDTO
     */
    'overlays': OverlayDTO;
    /**
     * 
     * @type {PeriodDuration}
     * @memberof EditFieldPresetDTO
     */
    'period_duration'?: PeriodDuration;
    /**
     * 
     * @type {Array<string>}
     * @memberof EditFieldPresetDTO
     */
    'shared_with_fields'?: Array<string>;
    /**
     * 
     * @type {SportResponseDTO}
     * @memberof EditFieldPresetDTO
     */
    'sport': SportResponseDTO;
    /**
     * 
     * @type {CommonValueDisplayNameDTOPresetStrategyEnum}
     * @memberof EditFieldPresetDTO
     */
    'style'?: CommonValueDisplayNameDTOPresetStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof EditFieldPresetDTO
     */
    'uuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const EnclosureTypeEnum = {
    Indoor: 'Indoor',
    Outdoor: 'Outdoor'
} as const;

export type EnclosureTypeEnum = typeof EnclosureTypeEnum[keyof typeof EnclosureTypeEnum];


/**
 * 
 * @export
 * @interface ExceptionDetail
 */
export interface ExceptionDetail {
    /**
     * 
     * @type {number}
     * @memberof ExceptionDetail
     */
    'code': number;
    /**
     * 
     * @type {string}
     * @memberof ExceptionDetail
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface FavoritePreset
 */
export interface FavoritePreset {
    /**
     * 
     * @type {boolean}
     * @memberof FavoritePreset
     */
    'favorited': boolean;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FeedNameEnum = {
    CleanFeed: 'clean_feed',
    Panorama: 'panorama'
} as const;

export type FeedNameEnum = typeof FeedNameEnum[keyof typeof FeedNameEnum];


/**
 * Main DTO to get all the information about a device
 * @export
 * @interface FieldConfigurationDTO
 */
export interface FieldConfigurationDTO {
    /**
     * 
     * @type {Array<SportCalibration>}
     * @memberof FieldConfigurationDTO
     */
    'configured_sports'?: Array<SportCalibration>;
    /**
     * 
     * @type {DeviceDetailsDTO}
     * @memberof FieldConfigurationDTO
     */
    'details'?: DeviceDetailsDTO;
    /**
     * 
     * @type {string}
     * @memberof FieldConfigurationDTO
     */
    'device_uuid': string;
    /**
     * 
     * @type {string}
     * @memberof FieldConfigurationDTO
     */
    'field_uuid': string;
    /**
     * 
     * @type {ResponseDeviceScoreboardDTO}
     * @memberof FieldConfigurationDTO
     */
    'scoreboard_configuration'?: ResponseDeviceScoreboardDTO;
}
/**
 * 
 * @export
 * @interface FieldDTO
 */
export interface FieldDTO {
    /**
     * 
     * @type {string}
     * @memberof FieldDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FieldDTO
     */
    'timezone'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldDTO
     */
    'type'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface FieldPresetDTO
 */
export interface FieldPresetDTO {
    /**
     * 
     * @type {number}
     * @memberof FieldPresetDTO
     */
    'atv_ocr_id'?: number;
    /**
     * 
     * @type {AudioSettings}
     * @memberof FieldPresetDTO
     */
    'audio': AudioSettings;
    /**
     * 
     * @type {{ [key: string]: Camera; }}
     * @memberof FieldPresetDTO
     */
    'camera': { [key: string]: Camera; };
    /**
     * 
     * @type {Array<number>}
     * @memberof FieldPresetDTO
     */
    'default_ocr_files'?: Array<number>;
    /**
     * 
     * @type {DestinationsInfoDTO}
     * @memberof FieldPresetDTO
     */
    'destinations_info': DestinationsInfoDTO;
    /**
     * 
     * @type {string}
     * @memberof FieldPresetDTO
     */
    'device_uuid': string;
    /**
     * 
     * @type {boolean}
     * @memberof FieldPresetDTO
     */
    'favorited'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FieldPresetDTO
     */
    'field_uuid': string;
    /**
     * 
     * @type {GraphicsEngineEnum}
     * @memberof FieldPresetDTO
     */
    'graphics_engine'?: GraphicsEngineEnum;
    /**
     * 
     * @type {ManualScorebugConfigurationDTO}
     * @memberof FieldPresetDTO
     */
    'manual_scorebug_configuration'?: ManualScorebugConfigurationDTO;
    /**
     * 
     * @type {CommonValueDisplayNameDTOPresetModeEnum}
     * @memberof FieldPresetDTO
     */
    'mode': CommonValueDisplayNameDTOPresetModeEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldPresetDTO
     */
    'name': string;
    /**
     * 
     * @type {NumPeriods}
     * @memberof FieldPresetDTO
     */
    'num_periods'?: NumPeriods;
    /**
     * 
     * @type {OverlayDTO}
     * @memberof FieldPresetDTO
     */
    'overlays': OverlayDTO;
    /**
     * 
     * @type {PeriodDuration}
     * @memberof FieldPresetDTO
     */
    'period_duration'?: PeriodDuration;
    /**
     * 
     * @type {Array<string>}
     * @memberof FieldPresetDTO
     */
    'shared_with_fields'?: Array<string>;
    /**
     * 
     * @type {SportResponseDTO}
     * @memberof FieldPresetDTO
     */
    'sport': SportResponseDTO;
    /**
     * 
     * @type {CommonValueDisplayNameDTOPresetStrategyEnum}
     * @memberof FieldPresetDTO
     */
    'style'?: CommonValueDisplayNameDTOPresetStrategyEnum;
    /**
     * 
     * @type {string}
     * @memberof FieldPresetDTO
     */
    'uuid'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const FieldTypeEnum = {
    Indoor: 'Indoor',
    Outdoor: 'Outdoor'
} as const;

export type FieldTypeEnum = typeof FieldTypeEnum[keyof typeof FieldTypeEnum];


/**
 * List of status to filter the devices.
 * @export
 * @interface FilterByStatus
 */
export interface FilterByStatus {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FrameRateEnum = {
    NUMBER_25: 25,
    NUMBER_30: 30
} as const;

export type FrameRateEnum = typeof FrameRateEnum[keyof typeof FrameRateEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const GraphicsEngineEnum = {
    SmartScorebug: 'smart_scorebug',
    CustomHtml: 'custom_html',
    ManualScorebug: 'manual_scorebug'
} as const;

export type GraphicsEngineEnum = typeof GraphicsEngineEnum[keyof typeof GraphicsEngineEnum];


/**
 * 
 * @export
 * @interface HTMLOverlayDTO
 */
export interface HTMLOverlayDTO {
    /**
     * 
     * @type {number}
     * @memberof HTMLOverlayDTO
     */
    'delay'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof HTMLOverlayDTO
     */
    'enabled'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof HTMLOverlayDTO
     */
    'is_manual'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof HTMLOverlayDTO
     */
    'url'?: string;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface IdPointDTO
 */
export interface IdPointDTO {
    /**
     * 
     * @type {number}
     * @memberof IdPointDTO
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof IdPointDTO
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof IdPointDTO
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface Image
 */
export interface Image {
    /**
     * 
     * @type {File}
     * @memberof Image
     */
    'base64': File;
    /**
     * 
     * @type {string}
     * @memberof Image
     */
    'format': string;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'height'?: number;
    /**
     * 
     * @type {number}
     * @memberof Image
     */
    'width'?: number;
}
/**
 * 
 * @export
 * @interface InitPresetDTO
 */
export interface InitPresetDTO {
    /**
     * 
     * @type {number}
     * @memberof InitPresetDTO
     */
    'atv_ocr_id'?: number;
    /**
     * 
     * @type {AudioSettings}
     * @memberof InitPresetDTO
     */
    'audio'?: AudioSettings;
    /**
     * 
     * @type {{ [key: string]: Camera; }}
     * @memberof InitPresetDTO
     */
    'camera'?: { [key: string]: Camera; };
    /**
     * 
     * @type {Array<number>}
     * @memberof InitPresetDTO
     */
    'default_ocr_files'?: Array<number>;
    /**
     * 
     * @type {DestinationsInfoDTO}
     * @memberof InitPresetDTO
     */
    'destinations_info'?: DestinationsInfoDTO;
    /**
     * 
     * @type {boolean}
     * @memberof InitPresetDTO
     */
    'favorited'?: boolean;
    /**
     * 
     * @type {ManualScorebugConfigurationDTO}
     * @memberof InitPresetDTO
     */
    'manual_scorebug_configuration'?: ManualScorebugConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof InitPresetDTO
     */
    'mode': string;
    /**
     * 
     * @type {string}
     * @memberof InitPresetDTO
     */
    'name': string;
    /**
     * 
     * @type {OverlayDTO}
     * @memberof InitPresetDTO
     */
    'overlays'?: OverlayDTO;
    /**
     * 
     * @type {Array<string>}
     * @memberof InitPresetDTO
     */
    'shared_with_fields'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof InitPresetDTO
     */
    'sport_uuid': string;
    /**
     * 
     * @type {string}
     * @memberof InitPresetDTO
     */
    'style'?: string;
    /**
     * 
     * @type {string}
     * @memberof InitPresetDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const LensSizeEnum = {
    Xs: 'XS',
    S: 'S',
    M: 'M',
    L: 'L'
} as const;

export type LensSizeEnum = typeof LensSizeEnum[keyof typeof LensSizeEnum];


/**
 * 
 * @export
 * @interface LicenseDeviceDTO
 */
export interface LicenseDeviceDTO {
    /**
     * 
     * @type {string}
     * @memberof LicenseDeviceDTO
     */
    'ticket_id': string;
}
/**
 * 
 * @export
 * @interface LocationInner
 */
export interface LocationInner {
}
/**
 * 
 * @export
 * @interface ManualScorebugConfigurationDTO
 */
export interface ManualScorebugConfigurationDTO {
    /**
     * 
     * @type {boolean}
     * @memberof ManualScorebugConfigurationDTO
     */
    'countdown'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ManualScorebugConfigurationDTO
     */
    'name'?: string;
    /**
     * 
     * @type {number}
     * @memberof ManualScorebugConfigurationDTO
     */
    'num_periods'?: number;
    /**
     * 
     * @type {string}
     * @memberof ManualScorebugConfigurationDTO
     */
    'overtime_duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof ManualScorebugConfigurationDTO
     */
    'period_duration'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ManualScorebugConfigurationDTO
     */
    'reset_timer'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ManualScorebugConfigurationDTO
     */
    'stop_timer'?: boolean;
}
/**
 * 
 * @export
 * @interface NumPeriods
 */
export interface NumPeriods {
}
/**
 * 
 * @export
 * @interface OcrCameraDTO
 */
export interface OcrCameraDTO {
    /**
     * 
     * @type {boolean}
     * @memberof OcrCameraDTO
     */
    'active': boolean;
    /**
     * 
     * @type {string}
     * @memberof OcrCameraDTO
     */
    'name': string;
    /**
     * 
     * @type {number}
     * @memberof OcrCameraDTO
     */
    'uid': number;
    /**
     * 
     * @type {string}
     * @memberof OcrCameraDTO
     */
    'uri': string;
    /**
     * 
     * @type {string}
     * @memberof OcrCameraDTO
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface OcrCamerasResponseDTO
 */
export interface OcrCamerasResponseDTO {
    /**
     * 
     * @type {Array<OcrCameraDTO>}
     * @memberof OcrCamerasResponseDTO
     */
    'cameras'?: Array<OcrCameraDTO>;
}
/**
 * 
 * @export
 * @interface OcrFilesDTO
 */
export interface OcrFilesDTO {
    /**
     * 
     * @type {string}
     * @memberof OcrFilesDTO
     */
    'content_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcrFilesDTO
     */
    'data'?: string;
    /**
     * 
     * @type {string}
     * @memberof OcrFilesDTO
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof OcrFilesDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface OptIdPointDTO
 */
export interface OptIdPointDTO {
    /**
     * 
     * @type {number}
     * @memberof OptIdPointDTO
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof OptIdPointDTO
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof OptIdPointDTO
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface Option
 */
export interface Option {
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'display_name'?: string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'validation_regex'?: string;
    /**
     * 
     * @type {string}
     * @memberof Option
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface OptionDetails
 */
export interface OptionDetails {
    /**
     * 
     * @type {string}
     * @memberof OptionDetails
     */
    'name': string;
    /**
     * 
     * @type {Array<Option>}
     * @memberof OptionDetails
     */
    'opts': Array<Option>;
    /**
     * 
     * @type {OptionTypeEnum}
     * @memberof OptionDetails
     */
    'type': OptionTypeEnum;
    /**
     * 
     * @type {UiHintEnum}
     * @memberof OptionDetails
     */
    'ui_hint'?: UiHintEnum;
    /**
     * 
     * @type {string}
     * @memberof OptionDetails
     */
    'units'?: string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const OptionTypeEnum = {
    Discrete: 'Discrete',
    Continuous: 'Continuous',
    Boolean: 'Boolean',
    Rectangle: 'Rectangle'
} as const;

export type OptionTypeEnum = typeof OptionTypeEnum[keyof typeof OptionTypeEnum];


/**
 * 
 * @export
 * @interface OrganizationDTO
 */
export interface OrganizationDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface OrganizationOptions
 */
export interface OrganizationOptions {
    /**
     * 
     * @type {string}
     * @memberof OrganizationOptions
     */
    'name': string;
    /**
     * 
     * @type {Array<Option>}
     * @memberof OrganizationOptions
     */
    'opts': Array<Option>;
    /**
     * 
     * @type {OrganizationUuid}
     * @memberof OrganizationOptions
     */
    'organization_uuid'?: OrganizationUuid;
    /**
     * 
     * @type {OptionTypeEnum}
     * @memberof OrganizationOptions
     */
    'type': OptionTypeEnum;
    /**
     * 
     * @type {UiHintEnum}
     * @memberof OrganizationOptions
     */
    'ui_hint'?: UiHintEnum;
    /**
     * 
     * @type {string}
     * @memberof OrganizationOptions
     */
    'units'?: string;
}


/**
 * 
 * @export
 * @interface OrganizationUuid
 */
export interface OrganizationUuid {
}
/**
 * 
 * @export
 * @interface OverlayDTO
 */
export interface OverlayDTO {
    /**
     * 
     * @type {HTMLOverlayDTO}
     * @memberof OverlayDTO
     */
    'html_overlay'?: HTMLOverlayDTO;
    /**
     * 
     * @type {Array<PresetImageDTO>}
     * @memberof OverlayDTO
     */
    'image_overlays'?: Array<PresetImageDTO>;
    /**
     * 
     * @type {Array<PipScoreboardDTO>}
     * @memberof OverlayDTO
     */
    'pip_overlays'?: Array<PipScoreboardDTO>;
}
/**
 * 
 * @export
 * @interface PageDeviceDTO
 */
export interface PageDeviceDTO {
    /**
     * 
     * @type {Array<DeviceDTO>}
     * @memberof PageDeviceDTO
     */
    'items': Array<DeviceDTO>;
    /**
     * 
     * @type {number}
     * @memberof PageDeviceDTO
     */
    'page': number;
    /**
     * 
     * @type {number}
     * @memberof PageDeviceDTO
     */
    'pages': number;
    /**
     * 
     * @type {number}
     * @memberof PageDeviceDTO
     */
    'size': number;
    /**
     * 
     * @type {number}
     * @memberof PageDeviceDTO
     */
    'total': number;
}
/**
 * 
 * @export
 * @interface PanoramaCalibrationDTO
 */
export interface PanoramaCalibrationDTO {
    /**
     * 
     * @type {Image}
     * @memberof PanoramaCalibrationDTO
     */
    'field': Image;
    /**
     * 
     * @type {Image}
     * @memberof PanoramaCalibrationDTO
     */
    'image': Image;
}
/**
 * 
 * @export
 * @interface PeriodDuration
 */
export interface PeriodDuration {
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PipOverlaySourceEnum = {
    Panorama: 'panorama',
    External: 'external'
} as const;

export type PipOverlaySourceEnum = typeof PipOverlaySourceEnum[keyof typeof PipOverlaySourceEnum];


/**
 * 
 * @export
 * @interface PipScoreboardDTO
 */
export interface PipScoreboardDTO {
    /**
     * 
     * @type {PositionDTO}
     * @memberof PipScoreboardDTO
     */
    'position': PositionDTO;
    /**
     * 
     * @type {PipOverlaySourceEnum}
     * @memberof PipScoreboardDTO
     */
    'source': PipOverlaySourceEnum;
    /**
     * 
     * @type {Array<PointDTO>}
     * @memberof PipScoreboardDTO
     */
    'source_crop': Array<PointDTO>;
}


/**
 * 
 * @export
 * @interface PointDTO
 */
export interface PointDTO {
    /**
     * 
     * @type {number}
     * @memberof PointDTO
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof PointDTO
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface PositionDTO
 */
export interface PositionDTO {
    /**
     * 
     * @type {number}
     * @memberof PositionDTO
     */
    'height': number;
    /**
     * 
     * @type {number}
     * @memberof PositionDTO
     */
    'width': number;
    /**
     * 
     * @type {number}
     * @memberof PositionDTO
     */
    'x': number;
    /**
     * 
     * @type {number}
     * @memberof PositionDTO
     */
    'y': number;
}
/**
 * 
 * @export
 * @interface PresetDestinationDTO
 */
export interface PresetDestinationDTO {
    /**
     * 
     * @type {string}
     * @memberof PresetDestinationDTO
     */
    'format'?: string;
    /**
     * 
     * @type {string}
     * @memberof PresetDestinationDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof PresetDestinationDTO
     */
    'protocol': string;
    /**
     * 
     * @type {string}
     * @memberof PresetDestinationDTO
     */
    'uri': string;
}
/**
 * 
 * @export
 * @interface PresetImageDTO
 */
export interface PresetImageDTO {
    /**
     * 
     * @type {Image}
     * @memberof PresetImageDTO
     */
    'image'?: Image;
    /**
     * 
     * @type {string}
     * @memberof PresetImageDTO
     */
    'image_uuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof PresetImageDTO
     */
    'name': string;
    /**
     * 
     * @type {PositionDTO}
     * @memberof PresetImageDTO
     */
    'position': PositionDTO;
    /**
     * 
     * @type {string}
     * @memberof PresetImageDTO
     */
    'uri'?: string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const PresetModeEnum = {
    Automatic: 'automatic',
    Manual: 'manual',
    Static: 'static'
} as const;

export type PresetModeEnum = typeof PresetModeEnum[keyof typeof PresetModeEnum];


/**
 * 
 * @export
 * @interface PresetProOverlaysDTO
 */
export interface PresetProOverlaysDTO {
    /**
     * 
     * @type {number}
     * @memberof PresetProOverlaysDTO
     */
    'atv_ocr_id'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PresetProOverlaysDTO
     */
    'default_ocr_files'?: Array<number>;
    /**
     * 
     * @type {GraphicsEngineEnum}
     * @memberof PresetProOverlaysDTO
     */
    'graphics_engine'?: GraphicsEngineEnum;
    /**
     * 
     * @type {ManualScorebugConfigurationDTO}
     * @memberof PresetProOverlaysDTO
     */
    'manual_scorebug_configuration'?: ManualScorebugConfigurationDTO;
    /**
     * 
     * @type {string}
     * @memberof PresetProOverlaysDTO
     */
    'name': string;
    /**
     * 
     * @type {ProOverlayDTO}
     * @memberof PresetProOverlaysDTO
     */
    'overlays'?: ProOverlayDTO;
    /**
     * 
     * @type {SportResponseDTO}
     * @memberof PresetProOverlaysDTO
     */
    'sport': SportResponseDTO;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PresetStrategyEnum = {
    Manual: 'Strategy_Manual',
    BasketballBroadcastAnalysis: 'Strategy_BasketballBroadcast_Analysis',
    FootballBroadcastAnalysis: 'Strategy_FootballBroadcast_Analysis',
    FutsalAnalysis: 'Strategy_Futsal_Analysis',
    HandballAnalysis: 'Strategy_Handball_Analysis',
    GenericScouting: 'Strategy_Generic_Scouting',
    IceHockeyAnalysis: 'Strategy_IceHockey_Analysis',
    ScoutingFeedAnalysis: 'Strategy_ScoutingFeed_Analysis',
    VolleyballAnalysis: 'Strategy_Volleyball_Analysis',
    ScoutingFeedLowCamAnalysis: 'Strategy_ScoutingFeedLowCam_Analysis',
    FootballLowCamAnalysis: 'Strategy_FootballLowCam_Analysis',
    Training: 'Strategy_Training',
    StaticLeftView: 'Strategy_StaticLeftView',
    StaticRightView: 'Strategy_StaticRightView'
} as const;

export type PresetStrategyEnum = typeof PresetStrategyEnum[keyof typeof PresetStrategyEnum];


/**
 * 
 * @export
 * @interface PresetUuid
 */
export interface PresetUuid {
}
/**
 * 
 * @export
 * @interface ProOverlayDTO
 */
export interface ProOverlayDTO {
    /**
     * 
     * @type {HTMLOverlayDTO}
     * @memberof ProOverlayDTO
     */
    'html_overlay'?: HTMLOverlayDTO;
}
/**
 * 
 * @export
 * @interface ProducerDTO
 */
export interface ProducerDTO {
    /**
     * 
     * @type {string}
     * @memberof ProducerDTO
     */
    'hostname': string;
    /**
     * 
     * @type {boolean}
     * @memberof ProducerDTO
     */
    'is_connected'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProducerDTO
     */
    'license_ticket_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProducerDTO
     */
    'license_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProducerDTO
     */
    'serial_number': string;
    /**
     * 
     * @type {ServerModelDTO}
     * @memberof ProducerDTO
     */
    'server_model'?: ServerModelDTO;
}
/**
 * 
 * @export
 * @interface RemoteSupportDTO
 */
export interface RemoteSupportDTO {
    /**
     * 
     * @type {boolean}
     * @memberof RemoteSupportDTO
     */
    'remote_support': boolean;
}
/**
 * 
 * @export
 * @interface ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch
 */
export interface ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch {
    /**
     * 
     * @type {Image}
     * @memberof ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch
     */
    'field': Image;
    /**
     * 
     * @type {Image}
     * @memberof ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch
     */
    'image': Image;
    /**
     * 
     * @type {string}
     * @memberof ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch
     */
    'status': string;
}
/**
 * DTO based on the third step of a field configuration
 * @export
 * @interface ResponseDeviceScoreboardDTO
 */
export interface ResponseDeviceScoreboardDTO {
    /**
     * 
     * @type {Array<ATVOCRPresetDTO>}
     * @memberof ResponseDeviceScoreboardDTO
     */
    'atv_ocr_presets'?: Array<ATVOCRPresetDTO>;
    /**
     * 
     * @type {string}
     * @memberof ResponseDeviceScoreboardDTO
     */
    'input_plugin'?: string;
    /**
     * 
     * @type {Array<ResponseOcrFilesDTO>}
     * @memberof ResponseDeviceScoreboardDTO
     */
    'ocr_files'?: Array<ResponseOcrFilesDTO>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResponseDeviceScoreboardDTO
     */
    'ocr_files_to_delete'?: Array<string>;
}
/**
 * 
 * @export
 * @interface ResponseLicenseDeviceDevicesDeviceUuidLicensePost
 */
export interface ResponseLicenseDeviceDevicesDeviceUuidLicensePost {
    /**
     * 
     * @type {Array<CameraDTO>}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'cameras'?: Array<CameraDTO>;
    /**
     * 
     * @type {EnclosureTypeEnum}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'enclosure_type'?: EnclosureTypeEnum;
    /**
     * 
     * @type {FieldTypeEnum}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'field_type'?: FieldTypeEnum;
    /**
     * 
     * @type {Array<FieldDTO>}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'fields'?: Array<FieldDTO>;
    /**
     * 
     * @type {FrameRateEnum}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'framerate'?: FrameRateEnum;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'is_configured'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'is_installed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'is_licensed'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'is_recording'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'is_registered'?: boolean;
    /**
     * 
     * @type {LensSizeEnum}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'lens_size'?: LensSizeEnum;
    /**
     * 
     * @type {string}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'name': string;
    /**
     * 
     * @type {OrganizationDTO}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'organization': OrganizationDTO;
    /**
     * 
     * @type {ProducerDTO}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'producer': ProducerDTO;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'software_failed'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {Array<SoftwareInstalledDTO>}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'software_installed'?: Array<SoftwareInstalledDTO>;
    /**
     * 
     * @type {Array<DeploymentDTO>}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'software_installing'?: Array<DeploymentDTO>;
    /**
     * 
     * @type {string}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseLicenseDeviceDevicesDeviceUuidLicensePost
     */
    'uuid'?: string;
}


/**
 * 
 * @export
 * @interface ResponseOcrFilesDTO
 */
export interface ResponseOcrFilesDTO {
    /**
     * 
     * @type {string}
     * @memberof ResponseOcrFilesDTO
     */
    'content_type'?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponseOcrFilesDTO
     */
    'filename': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseOcrFilesDTO
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface ResponseStartWizardSessionDevicesDeviceUuidSessionPost
 */
export interface ResponseStartWizardSessionDevicesDeviceUuidSessionPost {
    /**
     * 
     * @type {string}
     * @memberof ResponseStartWizardSessionDevicesDeviceUuidSessionPost
     */
    'token': string;
    /**
     * 
     * @type {string}
     * @memberof ResponseStartWizardSessionDevicesDeviceUuidSessionPost
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface SearchParam
 */
export interface SearchParam {
}
/**
 * 
 * @export
 * @interface ServerModelDTO
 */
export interface ServerModelDTO {
    /**
     * 
     * @type {string}
     * @memberof ServerModelDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SessionDTO
 */
export interface SessionDTO {
    /**
     * 
     * @type {string}
     * @memberof SessionDTO
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface SetFieldConfig
 */
export interface SetFieldConfig {
    /**
     * 
     * @type {DeviceDetailsProDTO}
     * @memberof SetFieldConfig
     */
    'details'?: DeviceDetailsProDTO;
    /**
     * 
     * @type {DeviceScoreboardDTO}
     * @memberof SetFieldConfig
     */
    'scoreboard_configuration'?: DeviceScoreboardDTO;
}
/**
 * 
 * @export
 * @interface SmartScoreboardTemplate
 */
export interface SmartScoreboardTemplate {
    /**
     * 
     * @type {Image}
     * @memberof SmartScoreboardTemplate
     */
    'image': Image;
}
/**
 * 
 * @export
 * @interface SoftwareAvailableDTO
 */
export interface SoftwareAvailableDTO {
    /**
     * 
     * @type {string}
     * @memberof SoftwareAvailableDTO
     */
    'name': string;
    /**
     * 
     * @type {VersionDTO}
     * @memberof SoftwareAvailableDTO
     */
    'version'?: VersionDTO;
}
/**
 * 
 * @export
 * @interface SoftwareDTO
 */
export interface SoftwareDTO {
    /**
     * 
     * @type {string}
     * @memberof SoftwareDTO
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface SoftwareInstalledDTO
 */
export interface SoftwareInstalledDTO {
    /**
     * 
     * @type {VersionDTO}
     * @memberof SoftwareInstalledDTO
     */
    'version'?: VersionDTO;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const SoftwareNameEnum = {
    Automatictv: 'automatictv',
    Atvedgesupport: 'atvedgesupport',
    Atvedgedeploy: 'atvedgedeploy'
} as const;

export type SoftwareNameEnum = typeof SoftwareNameEnum[keyof typeof SoftwareNameEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const SortDirectionOptions = {
    Asc: 'asc',
    Desc: 'desc'
} as const;

export type SortDirectionOptions = typeof SortDirectionOptions[keyof typeof SortDirectionOptions];


/**
 * DTO based on the second step of a field configuration
 * @export
 * @interface SportCalibration
 */
export interface SportCalibration {
    /**
     * 
     * @type {CalibrationBaseDTO}
     * @memberof SportCalibration
     */
    'calibration': CalibrationBaseDTO;
    /**
     * 
     * @type {SportResponseDTO}
     * @memberof SportCalibration
     */
    'sport': SportResponseDTO;
    /**
     * 
     * @type {string}
     * @memberof SportCalibration
     */
    'sportfield_name': string;
}
/**
 * 
 * @export
 * @interface SportDTO
 */
export interface SportDTO {
    /**
     * 
     * @type {string}
     * @memberof SportDTO
     */
    'icon_name': string;
    /**
     * 
     * @type {string}
     * @memberof SportDTO
     */
    'name': string;
    /**
     * 
     * @type {Array<SportDeviceDTO>}
     * @memberof SportDTO
     */
    'sportfields': Array<SportDeviceDTO>;
    /**
     * 
     * @type {string}
     * @memberof SportDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface SportDeviceDTO
 */
export interface SportDeviceDTO {
    /**
     * 
     * @type {string}
     * @memberof SportDeviceDTO
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof SportDeviceDTO
     */
    'value': string;
}
/**
 * 
 * @export
 * @interface SportGroupDTO
 */
export interface SportGroupDTO {
    /**
     * 
     * @type {string}
     * @memberof SportGroupDTO
     */
    'icon_name': string;
    /**
     * 
     * @type {string}
     * @memberof SportGroupDTO
     */
    'name': string;
    /**
     * 
     * @type {Array<SportDTO>}
     * @memberof SportGroupDTO
     */
    'sports': Array<SportDTO>;
}
/**
 * 
 * @export
 * @interface SportResponseDTO
 */
export interface SportResponseDTO {
    /**
     * 
     * @type {string}
     * @memberof SportResponseDTO
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SportResponseDTO
     */
    'period_duration'?: string;
    /**
     * 
     * @type {string}
     * @memberof SportResponseDTO
     */
    'uuid': string;
}
/**
 * 
 * @export
 * @interface SportUuid
 */
export interface SportUuid {
}
/**
 * The UUID sport reference that we return after you create a new sport from the API.
 * @export
 * @interface SportUuid1
 */
export interface SportUuid1 {
}
/**
 * Sport UUID to filter the graphics configuration
 * @export
 * @interface SportUuid2
 */
export interface SportUuid2 {
}
/**
 * 
 * @export
 * @interface StartCalibrationDTO
 */
export interface StartCalibrationDTO {
    /**
     * 
     * @type {string}
     * @memberof StartCalibrationDTO
     */
    'sportfield_name': string;
}
/**
 * 
 * @export
 * @interface StatusResponse
 */
export interface StatusResponse {
    /**
     * 
     * @type {string}
     * @memberof StatusResponse
     */
    'status': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TimeZonesEnum = {
    AfricaAbidjan: 'Africa/Abidjan',
    AfricaAccra: 'Africa/Accra',
    AfricaAddisAbaba: 'Africa/Addis_Ababa',
    AfricaAlgiers: 'Africa/Algiers',
    AfricaAsmara: 'Africa/Asmara',
    AfricaBamako: 'Africa/Bamako',
    AfricaBangui: 'Africa/Bangui',
    AfricaBanjul: 'Africa/Banjul',
    AfricaBissau: 'Africa/Bissau',
    AfricaBlantyre: 'Africa/Blantyre',
    AfricaBrazzaville: 'Africa/Brazzaville',
    AfricaBujumbura: 'Africa/Bujumbura',
    AfricaCairo: 'Africa/Cairo',
    AfricaCasablanca: 'Africa/Casablanca',
    AfricaCeuta: 'Africa/Ceuta',
    AfricaConakry: 'Africa/Conakry',
    AfricaDakar: 'Africa/Dakar',
    AfricaDarEsSalaam: 'Africa/Dar_es_Salaam',
    AfricaDjibouti: 'Africa/Djibouti',
    AfricaDouala: 'Africa/Douala',
    AfricaElAaiun: 'Africa/El_Aaiun',
    AfricaFreetown: 'Africa/Freetown',
    AfricaGaborone: 'Africa/Gaborone',
    AfricaHarare: 'Africa/Harare',
    AfricaJohannesburg: 'Africa/Johannesburg',
    AfricaJuba: 'Africa/Juba',
    AfricaKampala: 'Africa/Kampala',
    AfricaKhartoum: 'Africa/Khartoum',
    AfricaKigali: 'Africa/Kigali',
    AfricaKinshasa: 'Africa/Kinshasa',
    AfricaLagos: 'Africa/Lagos',
    AfricaLibreville: 'Africa/Libreville',
    AfricaLome: 'Africa/Lome',
    AfricaLuanda: 'Africa/Luanda',
    AfricaLubumbashi: 'Africa/Lubumbashi',
    AfricaLusaka: 'Africa/Lusaka',
    AfricaMalabo: 'Africa/Malabo',
    AfricaMaputo: 'Africa/Maputo',
    AfricaMaseru: 'Africa/Maseru',
    AfricaMbabane: 'Africa/Mbabane',
    AfricaMogadishu: 'Africa/Mogadishu',
    AfricaMonrovia: 'Africa/Monrovia',
    AfricaNairobi: 'Africa/Nairobi',
    AfricaNdjamena: 'Africa/Ndjamena',
    AfricaNiamey: 'Africa/Niamey',
    AfricaNouakchott: 'Africa/Nouakchott',
    AfricaOuagadougou: 'Africa/Ouagadougou',
    AfricaPortoNovo: 'Africa/Porto-Novo',
    AfricaSaoTome: 'Africa/Sao_Tome',
    AfricaTripoli: 'Africa/Tripoli',
    AfricaTunis: 'Africa/Tunis',
    AfricaWindhoek: 'Africa/Windhoek',
    AmericaAdak: 'America/Adak',
    AmericaAnchorage: 'America/Anchorage',
    AmericaAnguilla: 'America/Anguilla',
    AmericaAntigua: 'America/Antigua',
    AmericaAraguaina: 'America/Araguaina',
    AmericaArgentinaBuenosAires: 'America/Argentina/Buenos_Aires',
    AmericaArgentinaCatamarca: 'America/Argentina/Catamarca',
    AmericaArgentinaCordoba: 'America/Argentina/Cordoba',
    AmericaArgentinaJujuy: 'America/Argentina/Jujuy',
    AmericaArgentinaLaRioja: 'America/Argentina/La_Rioja',
    AmericaArgentinaMendoza: 'America/Argentina/Mendoza',
    AmericaArgentinaRioGallegos: 'America/Argentina/Rio_Gallegos',
    AmericaArgentinaSalta: 'America/Argentina/Salta',
    AmericaArgentinaSanJuan: 'America/Argentina/San_Juan',
    AmericaArgentinaSanLuis: 'America/Argentina/San_Luis',
    AmericaArgentinaTucuman: 'America/Argentina/Tucuman',
    AmericaArgentinaUshuaia: 'America/Argentina/Ushuaia',
    AmericaAruba: 'America/Aruba',
    AmericaAsuncion: 'America/Asuncion',
    AmericaAtikokan: 'America/Atikokan',
    AmericaBahia: 'America/Bahia',
    AmericaBahiaBanderas: 'America/Bahia_Banderas',
    AmericaBarbados: 'America/Barbados',
    AmericaBelem: 'America/Belem',
    AmericaBelize: 'America/Belize',
    AmericaBlancSablon: 'America/Blanc-Sablon',
    AmericaBoaVista: 'America/Boa_Vista',
    AmericaBogota: 'America/Bogota',
    AmericaBoise: 'America/Boise',
    AmericaCambridgeBay: 'America/Cambridge_Bay',
    AmericaCampoGrande: 'America/Campo_Grande',
    AmericaCancun: 'America/Cancun',
    AmericaCaracas: 'America/Caracas',
    AmericaCayenne: 'America/Cayenne',
    AmericaCayman: 'America/Cayman',
    AmericaChicago: 'America/Chicago',
    AmericaChihuahua: 'America/Chihuahua',
    AmericaCiudadJuarez: 'America/Ciudad_Juarez',
    AmericaCostaRica: 'America/Costa_Rica',
    AmericaCreston: 'America/Creston',
    AmericaCuiaba: 'America/Cuiaba',
    AmericaCuracao: 'America/Curacao',
    AmericaDanmarkshavn: 'America/Danmarkshavn',
    AmericaDawson: 'America/Dawson',
    AmericaDawsonCreek: 'America/Dawson_Creek',
    AmericaDenver: 'America/Denver',
    AmericaDetroit: 'America/Detroit',
    AmericaDominica: 'America/Dominica',
    AmericaEdmonton: 'America/Edmonton',
    AmericaEirunepe: 'America/Eirunepe',
    AmericaElSalvador: 'America/El_Salvador',
    AmericaFortNelson: 'America/Fort_Nelson',
    AmericaFortaleza: 'America/Fortaleza',
    AmericaGlaceBay: 'America/Glace_Bay',
    AmericaGooseBay: 'America/Goose_Bay',
    AmericaGrandTurk: 'America/Grand_Turk',
    AmericaGrenada: 'America/Grenada',
    AmericaGuadeloupe: 'America/Guadeloupe',
    AmericaGuatemala: 'America/Guatemala',
    AmericaGuayaquil: 'America/Guayaquil',
    AmericaGuyana: 'America/Guyana',
    AmericaHalifax: 'America/Halifax',
    AmericaHavana: 'America/Havana',
    AmericaHermosillo: 'America/Hermosillo',
    AmericaIndianaIndianapolis: 'America/Indiana/Indianapolis',
    AmericaIndianaKnox: 'America/Indiana/Knox',
    AmericaIndianaMarengo: 'America/Indiana/Marengo',
    AmericaIndianaPetersburg: 'America/Indiana/Petersburg',
    AmericaIndianaTellCity: 'America/Indiana/Tell_City',
    AmericaIndianaVevay: 'America/Indiana/Vevay',
    AmericaIndianaVincennes: 'America/Indiana/Vincennes',
    AmericaIndianaWinamac: 'America/Indiana/Winamac',
    AmericaInuvik: 'America/Inuvik',
    AmericaIqaluit: 'America/Iqaluit',
    AmericaJamaica: 'America/Jamaica',
    AmericaJuneau: 'America/Juneau',
    AmericaKentuckyLouisville: 'America/Kentucky/Louisville',
    AmericaKentuckyMonticello: 'America/Kentucky/Monticello',
    AmericaKralendijk: 'America/Kralendijk',
    AmericaLaPaz: 'America/La_Paz',
    AmericaLima: 'America/Lima',
    AmericaLosAngeles: 'America/Los_Angeles',
    AmericaLowerPrinces: 'America/Lower_Princes',
    AmericaMaceio: 'America/Maceio',
    AmericaManagua: 'America/Managua',
    AmericaManaus: 'America/Manaus',
    AmericaMarigot: 'America/Marigot',
    AmericaMartinique: 'America/Martinique',
    AmericaMatamoros: 'America/Matamoros',
    AmericaMazatlan: 'America/Mazatlan',
    AmericaMenominee: 'America/Menominee',
    AmericaMerida: 'America/Merida',
    AmericaMetlakatla: 'America/Metlakatla',
    AmericaMexicoCity: 'America/Mexico_City',
    AmericaMiquelon: 'America/Miquelon',
    AmericaMoncton: 'America/Moncton',
    AmericaMonterrey: 'America/Monterrey',
    AmericaMontevideo: 'America/Montevideo',
    AmericaMontserrat: 'America/Montserrat',
    AmericaNassau: 'America/Nassau',
    AmericaNewYork: 'America/New_York',
    AmericaNome: 'America/Nome',
    AmericaNoronha: 'America/Noronha',
    AmericaNorthDakotaBeulah: 'America/North_Dakota/Beulah',
    AmericaNorthDakotaCenter: 'America/North_Dakota/Center',
    AmericaNorthDakotaNewSalem: 'America/North_Dakota/New_Salem',
    AmericaNuuk: 'America/Nuuk',
    AmericaOjinaga: 'America/Ojinaga',
    AmericaPanama: 'America/Panama',
    AmericaParamaribo: 'America/Paramaribo',
    AmericaPhoenix: 'America/Phoenix',
    AmericaPortAuPrince: 'America/Port-au-Prince',
    AmericaPortOfSpain: 'America/Port_of_Spain',
    AmericaPortoVelho: 'America/Porto_Velho',
    AmericaPuertoRico: 'America/Puerto_Rico',
    AmericaPuntaArenas: 'America/Punta_Arenas',
    AmericaRankinInlet: 'America/Rankin_Inlet',
    AmericaRecife: 'America/Recife',
    AmericaRegina: 'America/Regina',
    AmericaResolute: 'America/Resolute',
    AmericaRioBranco: 'America/Rio_Branco',
    AmericaSantarem: 'America/Santarem',
    AmericaSantiago: 'America/Santiago',
    AmericaSantoDomingo: 'America/Santo_Domingo',
    AmericaSaoPaulo: 'America/Sao_Paulo',
    AmericaScoresbysund: 'America/Scoresbysund',
    AmericaSitka: 'America/Sitka',
    AmericaStBarthelemy: 'America/St_Barthelemy',
    AmericaStJohns: 'America/St_Johns',
    AmericaStKitts: 'America/St_Kitts',
    AmericaStLucia: 'America/St_Lucia',
    AmericaStThomas: 'America/St_Thomas',
    AmericaStVincent: 'America/St_Vincent',
    AmericaSwiftCurrent: 'America/Swift_Current',
    AmericaTegucigalpa: 'America/Tegucigalpa',
    AmericaThule: 'America/Thule',
    AmericaTijuana: 'America/Tijuana',
    AmericaToronto: 'America/Toronto',
    AmericaTortola: 'America/Tortola',
    AmericaVancouver: 'America/Vancouver',
    AmericaWhitehorse: 'America/Whitehorse',
    AmericaWinnipeg: 'America/Winnipeg',
    AmericaYakutat: 'America/Yakutat',
    AmericaYellowknife: 'America/Yellowknife',
    AntarcticaCasey: 'Antarctica/Casey',
    AntarcticaDavis: 'Antarctica/Davis',
    AntarcticaDumontDUrville: 'Antarctica/DumontDUrville',
    AntarcticaMacquarie: 'Antarctica/Macquarie',
    AntarcticaMawson: 'Antarctica/Mawson',
    AntarcticaMcMurdo: 'Antarctica/McMurdo',
    AntarcticaPalmer: 'Antarctica/Palmer',
    AntarcticaRothera: 'Antarctica/Rothera',
    AntarcticaSyowa: 'Antarctica/Syowa',
    AntarcticaTroll: 'Antarctica/Troll',
    AntarcticaVostok: 'Antarctica/Vostok',
    ArcticLongyearbyen: 'Arctic/Longyearbyen',
    AsiaAden: 'Asia/Aden',
    AsiaAlmaty: 'Asia/Almaty',
    AsiaAmman: 'Asia/Amman',
    AsiaAnadyr: 'Asia/Anadyr',
    AsiaAqtau: 'Asia/Aqtau',
    AsiaAqtobe: 'Asia/Aqtobe',
    AsiaAshgabat: 'Asia/Ashgabat',
    AsiaAtyrau: 'Asia/Atyrau',
    AsiaBaghdad: 'Asia/Baghdad',
    AsiaBahrain: 'Asia/Bahrain',
    AsiaBaku: 'Asia/Baku',
    AsiaBangkok: 'Asia/Bangkok',
    AsiaBarnaul: 'Asia/Barnaul',
    AsiaBeirut: 'Asia/Beirut',
    AsiaBishkek: 'Asia/Bishkek',
    AsiaBrunei: 'Asia/Brunei',
    AsiaChita: 'Asia/Chita',
    AsiaChoibalsan: 'Asia/Choibalsan',
    AsiaColombo: 'Asia/Colombo',
    AsiaDamascus: 'Asia/Damascus',
    AsiaDhaka: 'Asia/Dhaka',
    AsiaDili: 'Asia/Dili',
    AsiaDubai: 'Asia/Dubai',
    AsiaDushanbe: 'Asia/Dushanbe',
    AsiaFamagusta: 'Asia/Famagusta',
    AsiaGaza: 'Asia/Gaza',
    AsiaHebron: 'Asia/Hebron',
    AsiaHoChiMinh: 'Asia/Ho_Chi_Minh',
    AsiaHongKong: 'Asia/Hong_Kong',
    AsiaHovd: 'Asia/Hovd',
    AsiaIrkutsk: 'Asia/Irkutsk',
    AsiaJakarta: 'Asia/Jakarta',
    AsiaJayapura: 'Asia/Jayapura',
    AsiaJerusalem: 'Asia/Jerusalem',
    AsiaKabul: 'Asia/Kabul',
    AsiaKamchatka: 'Asia/Kamchatka',
    AsiaKarachi: 'Asia/Karachi',
    AsiaKathmandu: 'Asia/Kathmandu',
    AsiaKhandyga: 'Asia/Khandyga',
    AsiaKolkata: 'Asia/Kolkata',
    AsiaKrasnoyarsk: 'Asia/Krasnoyarsk',
    AsiaKualaLumpur: 'Asia/Kuala_Lumpur',
    AsiaKuching: 'Asia/Kuching',
    AsiaKuwait: 'Asia/Kuwait',
    AsiaMacau: 'Asia/Macau',
    AsiaMagadan: 'Asia/Magadan',
    AsiaMakassar: 'Asia/Makassar',
    AsiaManila: 'Asia/Manila',
    AsiaMuscat: 'Asia/Muscat',
    AsiaNicosia: 'Asia/Nicosia',
    AsiaNovokuznetsk: 'Asia/Novokuznetsk',
    AsiaNovosibirsk: 'Asia/Novosibirsk',
    AsiaOmsk: 'Asia/Omsk',
    AsiaOral: 'Asia/Oral',
    AsiaPhnomPenh: 'Asia/Phnom_Penh',
    AsiaPontianak: 'Asia/Pontianak',
    AsiaPyongyang: 'Asia/Pyongyang',
    AsiaQatar: 'Asia/Qatar',
    AsiaQostanay: 'Asia/Qostanay',
    AsiaQyzylorda: 'Asia/Qyzylorda',
    AsiaRiyadh: 'Asia/Riyadh',
    AsiaSakhalin: 'Asia/Sakhalin',
    AsiaSamarkand: 'Asia/Samarkand',
    AsiaSeoul: 'Asia/Seoul',
    AsiaShanghai: 'Asia/Shanghai',
    AsiaSingapore: 'Asia/Singapore',
    AsiaSrednekolymsk: 'Asia/Srednekolymsk',
    AsiaTaipei: 'Asia/Taipei',
    AsiaTashkent: 'Asia/Tashkent',
    AsiaTbilisi: 'Asia/Tbilisi',
    AsiaTehran: 'Asia/Tehran',
    AsiaThimphu: 'Asia/Thimphu',
    AsiaTokyo: 'Asia/Tokyo',
    AsiaTomsk: 'Asia/Tomsk',
    AsiaUlaanbaatar: 'Asia/Ulaanbaatar',
    AsiaUrumqi: 'Asia/Urumqi',
    AsiaUstNera: 'Asia/Ust-Nera',
    AsiaVientiane: 'Asia/Vientiane',
    AsiaVladivostok: 'Asia/Vladivostok',
    AsiaYakutsk: 'Asia/Yakutsk',
    AsiaYangon: 'Asia/Yangon',
    AsiaYekaterinburg: 'Asia/Yekaterinburg',
    AsiaYerevan: 'Asia/Yerevan',
    AtlanticAzores: 'Atlantic/Azores',
    AtlanticBermuda: 'Atlantic/Bermuda',
    AtlanticCanary: 'Atlantic/Canary',
    AtlanticCapeVerde: 'Atlantic/Cape_Verde',
    AtlanticFaroe: 'Atlantic/Faroe',
    AtlanticMadeira: 'Atlantic/Madeira',
    AtlanticReykjavik: 'Atlantic/Reykjavik',
    AtlanticSouthGeorgia: 'Atlantic/South_Georgia',
    AtlanticStHelena: 'Atlantic/St_Helena',
    AtlanticStanley: 'Atlantic/Stanley',
    AustraliaAdelaide: 'Australia/Adelaide',
    AustraliaBrisbane: 'Australia/Brisbane',
    AustraliaBrokenHill: 'Australia/Broken_Hill',
    AustraliaDarwin: 'Australia/Darwin',
    AustraliaEucla: 'Australia/Eucla',
    AustraliaHobart: 'Australia/Hobart',
    AustraliaLindeman: 'Australia/Lindeman',
    AustraliaLordHowe: 'Australia/Lord_Howe',
    AustraliaMelbourne: 'Australia/Melbourne',
    AustraliaPerth: 'Australia/Perth',
    AustraliaSydney: 'Australia/Sydney',
    CanadaAtlantic: 'Canada/Atlantic',
    CanadaCentral: 'Canada/Central',
    CanadaEastern: 'Canada/Eastern',
    CanadaMountain: 'Canada/Mountain',
    CanadaNewfoundland: 'Canada/Newfoundland',
    CanadaPacific: 'Canada/Pacific',
    EuropeAmsterdam: 'Europe/Amsterdam',
    EuropeAndorra: 'Europe/Andorra',
    EuropeAstrakhan: 'Europe/Astrakhan',
    EuropeAthens: 'Europe/Athens',
    EuropeBelgrade: 'Europe/Belgrade',
    EuropeBerlin: 'Europe/Berlin',
    EuropeBratislava: 'Europe/Bratislava',
    EuropeBrussels: 'Europe/Brussels',
    EuropeBucharest: 'Europe/Bucharest',
    EuropeBudapest: 'Europe/Budapest',
    EuropeBusingen: 'Europe/Busingen',
    EuropeChisinau: 'Europe/Chisinau',
    EuropeCopenhagen: 'Europe/Copenhagen',
    EuropeDublin: 'Europe/Dublin',
    EuropeGibraltar: 'Europe/Gibraltar',
    EuropeGuernsey: 'Europe/Guernsey',
    EuropeHelsinki: 'Europe/Helsinki',
    EuropeIsleOfMan: 'Europe/Isle_of_Man',
    EuropeIstanbul: 'Europe/Istanbul',
    EuropeJersey: 'Europe/Jersey',
    EuropeKaliningrad: 'Europe/Kaliningrad',
    EuropeKirov: 'Europe/Kirov',
    EuropeKyiv: 'Europe/Kyiv',
    EuropeLisbon: 'Europe/Lisbon',
    EuropeLjubljana: 'Europe/Ljubljana',
    EuropeLondon: 'Europe/London',
    EuropeLuxembourg: 'Europe/Luxembourg',
    EuropeMadrid: 'Europe/Madrid',
    EuropeMalta: 'Europe/Malta',
    EuropeMariehamn: 'Europe/Mariehamn',
    EuropeMinsk: 'Europe/Minsk',
    EuropeMonaco: 'Europe/Monaco',
    EuropeMoscow: 'Europe/Moscow',
    EuropeOslo: 'Europe/Oslo',
    EuropeParis: 'Europe/Paris',
    EuropePodgorica: 'Europe/Podgorica',
    EuropePrague: 'Europe/Prague',
    EuropeRiga: 'Europe/Riga',
    EuropeRome: 'Europe/Rome',
    EuropeSamara: 'Europe/Samara',
    EuropeSanMarino: 'Europe/San_Marino',
    EuropeSarajevo: 'Europe/Sarajevo',
    EuropeSaratov: 'Europe/Saratov',
    EuropeSimferopol: 'Europe/Simferopol',
    EuropeSkopje: 'Europe/Skopje',
    EuropeSofia: 'Europe/Sofia',
    EuropeStockholm: 'Europe/Stockholm',
    EuropeTallinn: 'Europe/Tallinn',
    EuropeTirane: 'Europe/Tirane',
    EuropeUlyanovsk: 'Europe/Ulyanovsk',
    EuropeVaduz: 'Europe/Vaduz',
    EuropeVatican: 'Europe/Vatican',
    EuropeVienna: 'Europe/Vienna',
    EuropeVilnius: 'Europe/Vilnius',
    EuropeVolgograd: 'Europe/Volgograd',
    EuropeWarsaw: 'Europe/Warsaw',
    EuropeZagreb: 'Europe/Zagreb',
    EuropeZurich: 'Europe/Zurich',
    Gmt: 'GMT',
    IndianAntananarivo: 'Indian/Antananarivo',
    IndianChagos: 'Indian/Chagos',
    IndianChristmas: 'Indian/Christmas',
    IndianCocos: 'Indian/Cocos',
    IndianComoro: 'Indian/Comoro',
    IndianKerguelen: 'Indian/Kerguelen',
    IndianMahe: 'Indian/Mahe',
    IndianMaldives: 'Indian/Maldives',
    IndianMauritius: 'Indian/Mauritius',
    IndianMayotte: 'Indian/Mayotte',
    IndianReunion: 'Indian/Reunion',
    PacificApia: 'Pacific/Apia',
    PacificAuckland: 'Pacific/Auckland',
    PacificBougainville: 'Pacific/Bougainville',
    PacificChatham: 'Pacific/Chatham',
    PacificChuuk: 'Pacific/Chuuk',
    PacificEaster: 'Pacific/Easter',
    PacificEfate: 'Pacific/Efate',
    PacificFakaofo: 'Pacific/Fakaofo',
    PacificFiji: 'Pacific/Fiji',
    PacificFunafuti: 'Pacific/Funafuti',
    PacificGalapagos: 'Pacific/Galapagos',
    PacificGambier: 'Pacific/Gambier',
    PacificGuadalcanal: 'Pacific/Guadalcanal',
    PacificGuam: 'Pacific/Guam',
    PacificHonolulu: 'Pacific/Honolulu',
    PacificKanton: 'Pacific/Kanton',
    PacificKiritimati: 'Pacific/Kiritimati',
    PacificKosrae: 'Pacific/Kosrae',
    PacificKwajalein: 'Pacific/Kwajalein',
    PacificMajuro: 'Pacific/Majuro',
    PacificMarquesas: 'Pacific/Marquesas',
    PacificMidway: 'Pacific/Midway',
    PacificNauru: 'Pacific/Nauru',
    PacificNiue: 'Pacific/Niue',
    PacificNorfolk: 'Pacific/Norfolk',
    PacificNoumea: 'Pacific/Noumea',
    PacificPagoPago: 'Pacific/Pago_Pago',
    PacificPalau: 'Pacific/Palau',
    PacificPitcairn: 'Pacific/Pitcairn',
    PacificPohnpei: 'Pacific/Pohnpei',
    PacificPortMoresby: 'Pacific/Port_Moresby',
    PacificRarotonga: 'Pacific/Rarotonga',
    PacificSaipan: 'Pacific/Saipan',
    PacificTahiti: 'Pacific/Tahiti',
    PacificTarawa: 'Pacific/Tarawa',
    PacificTongatapu: 'Pacific/Tongatapu',
    PacificWake: 'Pacific/Wake',
    PacificWallis: 'Pacific/Wallis',
    UsAlaska: 'US/Alaska',
    UsArizona: 'US/Arizona',
    UsCentral: 'US/Central',
    UsEastern: 'US/Eastern',
    UsHawaii: 'US/Hawaii',
    UsMountain: 'US/Mountain',
    UsPacific: 'US/Pacific',
    Utc: 'UTC'
} as const;

export type TimeZonesEnum = typeof TimeZonesEnum[keyof typeof TimeZonesEnum];


/**
 * 
 * @export
 * @interface TransferPresetWithDTO
 */
export interface TransferPresetWithDTO {
    /**
     * 
     * @type {OrganizationUuid}
     * @memberof TransferPresetWithDTO
     */
    'organization_uuid'?: OrganizationUuid;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const TypeEnum = {
    Input: 'input',
    Output: 'output'
} as const;

export type TypeEnum = typeof TypeEnum[keyof typeof TypeEnum];


/**
 * 
 * @export
 * @enum {string}
 */

export const UiHintEnum = {
    ComboBox: 'ComboBox',
    Slider: 'Slider',
    Toogle: 'Toogle'
} as const;

export type UiHintEnum = typeof UiHintEnum[keyof typeof UiHintEnum];


/**
 * 
 * @export
 * @interface Upgrade
 */
export interface Upgrade {
}
/**
 * 
 * @export
 * @interface UserDTO
 */
export interface UserDTO {
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    'first_name': string;
    /**
     * 
     * @type {boolean}
     * @memberof UserDTO
     */
    'is_superadmin': boolean;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    'last_name': string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof UserDTO
     */
    'uuid'?: string;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<LocationInner>}
     * @memberof ValidationError
     */
    'loc': Array<LocationInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface Value
 */
export interface Value {
}
/**
 * 
 * @export
 * @interface VersionDTO
 */
export interface VersionDTO {
    /**
     * 
     * @type {SoftwareDTO}
     * @memberof VersionDTO
     */
    'software'?: SoftwareDTO;
    /**
     * 
     * @type {string}
     * @memberof VersionDTO
     */
    'version_number'?: string;
}

/**
 * AuthenticationApi - axios parameter creator
 * @export
 */
export const AuthenticationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Auth Url
         * @param {string} state Random hexadecimal parameter
         * @param {string} codeChallenge BASE64-URL-encoded string of the SHA256 hash of the code verifier
         * @param {string} redirectUri Redirect uri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUrlAuthUrlGet: async (state: string, codeChallenge: string, redirectUri: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'state' is not null or undefined
            assertParamExists('authUrlAuthUrlGet', 'state', state)
            // verify required parameter 'codeChallenge' is not null or undefined
            assertParamExists('authUrlAuthUrlGet', 'codeChallenge', codeChallenge)
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('authUrlAuthUrlGet', 'redirectUri', redirectUri)
            const localVarPath = `/auth/url/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (state !== undefined) {
                localVarQueryParameter['state'] = state;
            }

            if (codeChallenge !== undefined) {
                localVarQueryParameter['code_challenge'] = codeChallenge;
            }

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint is only used to test the API from Swagger UI, the frontend application will use the Authorization Code + PKCE Flow.
         * @summary Login With Password
         * @param {string} password 
         * @param {string} username 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPasswordAuthLoginPost: async (password: string, username: string, clientId?: string, clientSecret?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'password' is not null or undefined
            assertParamExists('loginWithPasswordAuthLoginPost', 'password', password)
            // verify required parameter 'username' is not null or undefined
            assertParamExists('loginWithPasswordAuthLoginPost', 'username', username)
            const localVarPath = `/auth/login/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (clientId !== undefined) {
                localVarQueryParameter['client_id'] = clientId;
            }

            if (clientSecret !== undefined) {
                localVarQueryParameter['client_secret'] = clientSecret;
            }


            if (password !== undefined) { 
                localVarFormParams.set('password', password as any);
            }
    
            if (username !== undefined) { 
                localVarFormParams.set('username', username as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams.toString();

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAuthLogoutPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Token From Code
         * @param {string} redirectUri Redirect uri
         * @param {string} code Random hexadecimal
         * @param {string} codeVerifier Cryptographically random string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFromCodeAuthTokenPost: async (redirectUri: string, code: string, codeVerifier: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'redirectUri' is not null or undefined
            assertParamExists('tokenFromCodeAuthTokenPost', 'redirectUri', redirectUri)
            // verify required parameter 'code' is not null or undefined
            assertParamExists('tokenFromCodeAuthTokenPost', 'code', code)
            // verify required parameter 'codeVerifier' is not null or undefined
            assertParamExists('tokenFromCodeAuthTokenPost', 'codeVerifier', codeVerifier)
            const localVarPath = `/auth/token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (redirectUri !== undefined) {
                localVarQueryParameter['redirect_uri'] = redirectUri;
            }

            if (code !== undefined) {
                localVarQueryParameter['code'] = code;
            }

            if (codeVerifier !== undefined) {
                localVarQueryParameter['code_verifier'] = codeVerifier;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Token From Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFromRefreshTokenAuthRefreshTokenPost: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/refresh_token/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationApi - functional programming interface
 * @export
 */
export const AuthenticationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthenticationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Auth Url
         * @param {string} state Random hexadecimal parameter
         * @param {string} codeChallenge BASE64-URL-encoded string of the SHA256 hash of the code verifier
         * @param {string} redirectUri Redirect uri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authUrlAuthUrlGet(state: string, codeChallenge: string, redirectUri: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authUrlAuthUrlGet(state, codeChallenge, redirectUri, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint is only used to test the API from Swagger UI, the frontend application will use the Authorization Code + PKCE Flow.
         * @summary Login With Password
         * @param {string} password 
         * @param {string} username 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginWithPasswordAuthLoginPost(password: string, username: string, clientId?: string, clientSecret?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginWithPasswordAuthLoginPost(password, username, clientId, clientSecret, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async logoutAuthLogoutPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.logoutAuthLogoutPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Token From Code
         * @param {string} redirectUri Redirect uri
         * @param {string} code Random hexadecimal
         * @param {string} codeVerifier Cryptographically random string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenFromCodeAuthTokenPost(redirectUri: string, code: string, codeVerifier: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenFromCodeAuthTokenPost(redirectUri, code, codeVerifier, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Token From Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tokenFromRefreshTokenAuthRefreshTokenPost(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.tokenFromRefreshTokenAuthRefreshTokenPost(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AuthenticationApi - factory interface
 * @export
 */
export const AuthenticationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthenticationApiFp(configuration)
    return {
        /**
         * 
         * @summary Auth Url
         * @param {string} state Random hexadecimal parameter
         * @param {string} codeChallenge BASE64-URL-encoded string of the SHA256 hash of the code verifier
         * @param {string} redirectUri Redirect uri
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authUrlAuthUrlGet(state: string, codeChallenge: string, redirectUri: string, options?: any): AxiosPromise<void> {
            return localVarFp.authUrlAuthUrlGet(state, codeChallenge, redirectUri, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is only used to test the API from Swagger UI, the frontend application will use the Authorization Code + PKCE Flow.
         * @summary Login With Password
         * @param {string} password 
         * @param {string} username 
         * @param {string} [clientId] 
         * @param {string} [clientSecret] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginWithPasswordAuthLoginPost(password: string, username: string, clientId?: string, clientSecret?: string, options?: any): AxiosPromise<any> {
            return localVarFp.loginWithPasswordAuthLoginPost(password, username, clientId, clientSecret, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutAuthLogoutPost(options?: any): AxiosPromise<void> {
            return localVarFp.logoutAuthLogoutPost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Token From Code
         * @param {string} redirectUri Redirect uri
         * @param {string} code Random hexadecimal
         * @param {string} codeVerifier Cryptographically random string
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFromCodeAuthTokenPost(redirectUri: string, code: string, codeVerifier: string, options?: any): AxiosPromise<void> {
            return localVarFp.tokenFromCodeAuthTokenPost(redirectUri, code, codeVerifier, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Token From Refresh Token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tokenFromRefreshTokenAuthRefreshTokenPost(options?: any): AxiosPromise<void> {
            return localVarFp.tokenFromRefreshTokenAuthRefreshTokenPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthenticationApi - object-oriented interface
 * @export
 * @class AuthenticationApi
 * @extends {BaseAPI}
 */
export class AuthenticationApi extends BaseAPI {
    /**
     * 
     * @summary Auth Url
     * @param {string} state Random hexadecimal parameter
     * @param {string} codeChallenge BASE64-URL-encoded string of the SHA256 hash of the code verifier
     * @param {string} redirectUri Redirect uri
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public authUrlAuthUrlGet(state: string, codeChallenge: string, redirectUri: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).authUrlAuthUrlGet(state, codeChallenge, redirectUri, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint is only used to test the API from Swagger UI, the frontend application will use the Authorization Code + PKCE Flow.
     * @summary Login With Password
     * @param {string} password 
     * @param {string} username 
     * @param {string} [clientId] 
     * @param {string} [clientSecret] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public loginWithPasswordAuthLoginPost(password: string, username: string, clientId?: string, clientSecret?: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).loginWithPasswordAuthLoginPost(password, username, clientId, clientSecret, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public logoutAuthLogoutPost(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).logoutAuthLogoutPost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Token From Code
     * @param {string} redirectUri Redirect uri
     * @param {string} code Random hexadecimal
     * @param {string} codeVerifier Cryptographically random string
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public tokenFromCodeAuthTokenPost(redirectUri: string, code: string, codeVerifier: string, options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).tokenFromCodeAuthTokenPost(redirectUri, code, codeVerifier, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Token From Refresh Token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApi
     */
    public tokenFromRefreshTokenAuthRefreshTokenPost(options?: AxiosRequestConfig) {
        return AuthenticationApiFp(this.configuration).tokenFromRefreshTokenAuthRefreshTokenPost(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CalibrationApi - axios parameter creator
 * @export
 */
export const CalibrationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Calibrate Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {CalibrationDTO} calibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch: async (deviceUuid: string, fieldUuid: string, sportUuid: string, requestId: string, calibrationDTO: CalibrationDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch', 'sportUuid', sportUuid)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch', 'requestId', requestId)
            // verify required parameter 'calibrationDTO' is not null or undefined
            assertParamExists('calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch', 'calibrationDTO', calibrationDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/calibrate`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (requestId !== undefined) {
                localVarQueryParameter['request_id'] = requestId;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(calibrationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Delete Calibrated Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete: async (deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the current calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Camera Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {number} cameraId 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet: async (deviceUuid: string, fieldUuid: string, sportUuid: string, cameraId: number, onlyImage?: boolean, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet', 'sportUuid', sportUuid)
            // verify required parameter 'cameraId' is not null or undefined
            assertParamExists('getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet', 'cameraId', cameraId)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/cameras/{camera_id}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)))
                .replace(`{${"camera_id"}}`, encodeURIComponent(String(cameraId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (onlyImage !== undefined) {
                localVarQueryParameter['only_image'] = onlyImage;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the panorama calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Panorama Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet: async (deviceUuid: string, fieldUuid: string, sportUuid: string, onlyImage?: boolean, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/panorama/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (onlyImage !== undefined) {
                localVarQueryParameter['only_image'] = onlyImage;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Save Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost: async (deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to prepare the camera for the calibration, should be called when clicking on \'Start Calibration\' button. To make this, we need the information from the 1st step of the field configuration
         * @summary Start Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {StartCalibrationDTO} startCalibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost: async (deviceUuid: string, fieldUuid: string, sportUuid: string, startCalibrationDTO: StartCalibrationDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost', 'sportUuid', sportUuid)
            // verify required parameter 'startCalibrationDTO' is not null or undefined
            assertParamExists('startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost', 'startCalibrationDTO', startCalibrationDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/start`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(startCalibrationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to unload the calibration should be called when clicking on \'back\' button.
         * @summary Unload Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost: async (deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/calibration/sports/{sport_uuid}/unload`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CalibrationApi - functional programming interface
 * @export
 */
export const CalibrationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CalibrationApiAxiosParamCreator(configuration)
    return {
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Calibrate Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {CalibrationDTO} calibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid: string, fieldUuid: string, sportUuid: string, requestId: string, calibrationDTO: CalibrationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid, fieldUuid, sportUuid, requestId, calibrationDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Delete Calibrated Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the current calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Camera Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {number} cameraId 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid: string, fieldUuid: string, sportUuid: string, cameraId: number, onlyImage?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraCalibrationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid, fieldUuid, sportUuid, cameraId, onlyImage, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the panorama calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Panorama Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid: string, fieldUuid: string, sportUuid: string, onlyImage?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CameraCalibrationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid, fieldUuid, sportUuid, onlyImage, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Save Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to prepare the camera for the calibration, should be called when clicking on \'Start Calibration\' button. To make this, we need the information from the 1st step of the field configuration
         * @summary Start Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {StartCalibrationDTO} startCalibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid: string, fieldUuid: string, sportUuid: string, startCalibrationDTO: StartCalibrationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid, fieldUuid, sportUuid, startCalibrationDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to unload the calibration should be called when clicking on \'back\' button.
         * @summary Unload Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CalibrationApi - factory interface
 * @export
 */
export const CalibrationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CalibrationApiFp(configuration)
    return {
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Calibrate Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {CalibrationDTO} calibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid: string, fieldUuid: string, sportUuid: string, requestId: string, calibrationDTO: CalibrationDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<ResponseCalibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch> {
            return localVarFp.calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid, fieldUuid, sportUuid, requestId, calibrationDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Delete Calibrated Sport
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the current calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Camera Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {number} cameraId 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid: string, fieldUuid: string, sportUuid: string, cameraId: number, onlyImage?: boolean, xWizardSessionToken?: string, options?: any): AxiosPromise<CameraCalibrationDTO> {
            return localVarFp.getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid, fieldUuid, sportUuid, cameraId, onlyImage, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the panorama calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
         * @summary Get Panorama Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {boolean} [onlyImage] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid: string, fieldUuid: string, sportUuid: string, onlyImage?: boolean, xWizardSessionToken?: string, options?: any): AxiosPromise<CameraCalibrationDTO> {
            return localVarFp.getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid, fieldUuid, sportUuid, onlyImage, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Send calibration points to a device, and return the current calibration with an image
         * @summary Save Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to prepare the camera for the calibration, should be called when clicking on \'Start Calibration\' button. To make this, we need the information from the 1st step of the field configuration
         * @summary Start Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {StartCalibrationDTO} startCalibrationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid: string, fieldUuid: string, sportUuid: string, startCalibrationDTO: StartCalibrationDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid, fieldUuid, sportUuid, startCalibrationDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to unload the calibration should be called when clicking on \'back\' button.
         * @summary Unload Calibration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CalibrationApi - object-oriented interface
 * @export
 * @class CalibrationApi
 * @extends {BaseAPI}
 */
export class CalibrationApi extends BaseAPI {
    /**
     * Send calibration points to a device, and return the current calibration with an image
     * @summary Calibrate Sport
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {string} requestId Request identifier to create a pull if requests timeout
     * @param {CalibrationDTO} calibrationDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid: string, fieldUuid: string, sportUuid: string, requestId: string, calibrationDTO: CalibrationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).calibrateSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCalibratePatch(deviceUuid, fieldUuid, sportUuid, requestId, calibrationDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send calibration points to a device, and return the current calibration with an image
     * @summary Delete Calibrated Sport
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).deleteCalibratedSportDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidDelete(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the current calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
     * @summary Get Camera Calibration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {number} cameraId 
     * @param {boolean} [onlyImage] 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid: string, fieldUuid: string, sportUuid: string, cameraId: number, onlyImage?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getCameraCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidCamerasCameraIdGet(deviceUuid, fieldUuid, sportUuid, cameraId, onlyImage, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the panorama calibration of specific sportfield with an image. This endpoint will load the sport into the producer before asking for the image
     * @summary Get Panorama Calibration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {boolean} [onlyImage] 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid: string, fieldUuid: string, sportUuid: string, onlyImage?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).getPanoramaCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPanoramaGet(deviceUuid, fieldUuid, sportUuid, onlyImage, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Send calibration points to a device, and return the current calibration with an image
     * @summary Save Calibration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).saveCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to prepare the camera for the calibration, should be called when clicking on \'Start Calibration\' button. To make this, we need the information from the 1st step of the field configuration
     * @summary Start Calibration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {StartCalibrationDTO} startCalibrationDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid: string, fieldUuid: string, sportUuid: string, startCalibrationDTO: StartCalibrationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).startCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidStartPost(deviceUuid, fieldUuid, sportUuid, startCalibrationDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to unload the calibration should be called when clicking on \'back\' button.
     * @summary Unload Calibration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CalibrationApi
     */
    public unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return CalibrationApiFp(this.configuration).unloadCalibrationDevicesDeviceUuidFieldsFieldUuidCalibrationSportsSportUuidUnloadPost(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * CamerasApi - axios parameter creator
 * @export
 */
export const CamerasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraTypesOptionsCameraTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/options/camera_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CamerasApi - functional programming interface
 * @export
 */
export const CamerasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CamerasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCameraTypesOptionsCameraTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCameraTypesOptionsCameraTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CamerasApi - factory interface
 * @export
 */
export const CamerasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CamerasApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraTypesOptionsCameraTypesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getCameraTypesOptionsCameraTypesGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CamerasApi - object-oriented interface
 * @export
 * @class CamerasApi
 * @extends {BaseAPI}
 */
export class CamerasApi extends BaseAPI {
    /**
     * 
     * @summary Get Camera Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CamerasApi
     */
    public getCameraTypesOptionsCameraTypesGet(options?: AxiosRequestConfig) {
        return CamerasApiFp(this.configuration).getCameraTypesOptionsCameraTypesGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DefaultApi - axios parameter creator
 * @export
 */
export const DefaultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootHealthzGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/healthz/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async rootHealthzGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.rootHealthzGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultApiFp(configuration)
    return {
        /**
         * 
         * @summary Root
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        rootHealthzGet(options?: any): AxiosPromise<any> {
            return localVarFp.rootHealthzGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @summary Root
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public rootHealthzGet(options?: AxiosRequestConfig) {
        return DefaultApiFp(this.configuration).rootHealthzGet(options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * DevicesApi - axios parameter creator
 * @export
 */
export const DevicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clear Wizard Session
         * @param {string} deviceUuid 
         * @param {string} xExpiryTimestamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearWizardSessionDevicesDeviceUuidSessionClearDelete: async (deviceUuid: string, xExpiryTimestamp: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('clearWizardSessionDevicesDeviceUuidSessionClearDelete', 'deviceUuid', deviceUuid)
            // verify required parameter 'xExpiryTimestamp' is not null or undefined
            assertParamExists('clearWizardSessionDevicesDeviceUuidSessionClearDelete', 'xExpiryTimestamp', xExpiryTimestamp)
            const localVarPath = `/devices/{device_uuid}/session/clear/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication InternalTokenHeader required
            await setApiKeyToObject(localVarHeaderParameter, "Internal-Token", configuration)

            if (xExpiryTimestamp != null) {
                localVarHeaderParameter['x-expiry-timestamp'] = String(xExpiryTimestamp);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deploy Automatictv
         * @param {string} deviceUuid 
         * @param {Upgrade} [upgrade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployAutomatictvDevicesDeviceUuidDeployPost: async (deviceUuid: string, upgrade?: Upgrade, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('deployAutomatictvDevicesDeviceUuidDeployPost', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/deploy/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (upgrade !== undefined) {
                localVarQueryParameter['upgrade'] = upgrade;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Deploy Remote Support
         * @param {string} deviceUuid 
         * @param {RemoteSupportDTO} remoteSupportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployRemoteSupportDevicesDeviceUuidRemoteSupportPost: async (deviceUuid: string, remoteSupportDTO: RemoteSupportDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('deployRemoteSupportDevicesDeviceUuidRemoteSupportPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'remoteSupportDTO' is not null or undefined
            assertParamExists('deployRemoteSupportDevicesDeviceUuidRemoteSupportPost', 'remoteSupportDTO', remoteSupportDTO)
            const localVarPath = `/devices/{device_uuid}/remote_support/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(remoteSupportDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Deployment
         * @param {string} deviceUuid 
         * @param {string} deploymentUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet: async (deviceUuid: string, deploymentUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'deploymentUuid' is not null or undefined
            assertParamExists('getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet', 'deploymentUuid', deploymentUuid)
            const localVarPath = `/devices/{device_uuid}/deploy/{deployment_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"deployment_uuid"}}`, encodeURIComponent(String(deploymentUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Device Detail
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceDetailDevicesDeviceUuidGet: async (deviceUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getDeviceDetailDevicesDeviceUuidGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Devices List
         * @param {SearchParam} [search] 
         * @param {FilterByStatus} [status] List of status to filter the devices.
         * @param {DevicesSortOptions} [orderBy] 
         * @param {SortDirectionOptions} [orderDir] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesListDevicesGet: async (search?: SearchParam, status?: FilterByStatus, orderBy?: DevicesSortOptions, orderDir?: SortDirectionOptions, page?: number, size?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/devices/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['order_by'] = orderBy;
            }

            if (orderDir !== undefined) {
                localVarQueryParameter['order_dir'] = orderDir;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Ocr Cameras
         * @param {string} deviceUuid 
         * @param {boolean} [onlyActive] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrCamerasDevicesDeviceUuidOcrCamerasGet: async (deviceUuid: string, onlyActive?: boolean, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getOcrCamerasDevicesDeviceUuidOcrCamerasGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/ocr_cameras/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (onlyActive !== undefined) {
                localVarQueryParameter['only_active'] = onlyActive;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary License Device
         * @param {string} deviceUuid 
         * @param {LicenseDeviceDTO} licenseDeviceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseDeviceDevicesDeviceUuidLicensePost: async (deviceUuid: string, licenseDeviceDTO: LicenseDeviceDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('licenseDeviceDevicesDeviceUuidLicensePost', 'deviceUuid', deviceUuid)
            // verify required parameter 'licenseDeviceDTO' is not null or undefined
            assertParamExists('licenseDeviceDevicesDeviceUuidLicensePost', 'licenseDeviceDTO', licenseDeviceDTO)
            const localVarPath = `/devices/{device_uuid}/license/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(licenseDeviceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDTO} editDeviceDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigDevicesDeviceUuidPut: async (deviceUuid: string, editDeviceDTO: EditDeviceDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setDeviceConfigDevicesDeviceUuidPut', 'deviceUuid', deviceUuid)
            // verify required parameter 'editDeviceDTO' is not null or undefined
            assertParamExists('setDeviceConfigDevicesDeviceUuidPut', 'editDeviceDTO', editDeviceDTO)
            const localVarPath = `/devices/{device_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDeviceDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigProDevicesDeviceUuidPut: async (deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setDeviceConfigProDevicesDeviceUuidPut', 'deviceUuid', deviceUuid)
            // verify required parameter 'editDeviceDetailsDTO' is not null or undefined
            assertParamExists('setDeviceConfigProDevicesDeviceUuidPut', 'editDeviceDetailsDTO', editDeviceDetailsDTO)
            const localVarPath = `/pro/devices/{device_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDeviceDetailsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Start Wizard Session
         * @param {string} deviceUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {string} [fieldUuid] Field UUID to start the session
         * @param {boolean} [force] If true, it will force the creation of a new session
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWizardSessionDevicesDeviceUuidSessionPost: async (deviceUuid: string, requestId: string, fieldUuid?: string, force?: boolean, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('startWizardSessionDevicesDeviceUuidSessionPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'requestId' is not null or undefined
            assertParamExists('startWizardSessionDevicesDeviceUuidSessionPost', 'requestId', requestId)
            const localVarPath = `/devices/{device_uuid}/session/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (fieldUuid !== undefined) {
                localVarQueryParameter['field_uuid'] = fieldUuid;
            }

            if (requestId !== undefined) {
                localVarQueryParameter['request_id'] = requestId;
            }

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Stop Wizard Session
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopWizardSessionDevicesDeviceUuidSessionDelete: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('stopWizardSessionDevicesDeviceUuidSessionDelete', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/session/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevicesApi - functional programming interface
 * @export
 */
export const DevicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clear Wizard Session
         * @param {string} deviceUuid 
         * @param {string} xExpiryTimestamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid: string, xExpiryTimestamp: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid, xExpiryTimestamp, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deploy Automatictv
         * @param {string} deviceUuid 
         * @param {Upgrade} [upgrade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid: string, upgrade?: Upgrade, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceDeploymentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid, upgrade, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Deploy Remote Support
         * @param {string} deviceUuid 
         * @param {RemoteSupportDTO} remoteSupportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid: string, remoteSupportDTO: RemoteSupportDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceDeploymentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid, remoteSupportDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Deployment
         * @param {string} deviceUuid 
         * @param {string} deploymentUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid: string, deploymentUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceDeploymentDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid, deploymentUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Device Detail
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDeviceDetailDevicesDeviceUuidGet(deviceUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceWithCamerasDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDeviceDetailDevicesDeviceUuidGet(deviceUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Devices List
         * @param {SearchParam} [search] 
         * @param {FilterByStatus} [status] List of status to filter the devices.
         * @param {DevicesSortOptions} [orderBy] 
         * @param {SortDirectionOptions} [orderDir] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDevicesListDevicesGet(search?: SearchParam, status?: FilterByStatus, orderBy?: DevicesSortOptions, orderDir?: SortDirectionOptions, page?: number, size?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PageDeviceDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDevicesListDevicesGet(search, status, orderBy, orderDir, page, size, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Ocr Cameras
         * @param {string} deviceUuid 
         * @param {boolean} [onlyActive] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid: string, onlyActive?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OcrCamerasResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid, onlyActive, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary License Device
         * @param {string} deviceUuid 
         * @param {LicenseDeviceDTO} licenseDeviceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid: string, licenseDeviceDTO: LicenseDeviceDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseLicenseDeviceDevicesDeviceUuidLicensePost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid, licenseDeviceDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDTO} editDeviceDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDeviceConfigDevicesDeviceUuidPut(deviceUuid: string, editDeviceDTO: EditDeviceDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDeviceConfigDevicesDeviceUuidPut(deviceUuid, editDeviceDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Start Wizard Session
         * @param {string} deviceUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {string} [fieldUuid] Field UUID to start the session
         * @param {boolean} [force] If true, it will force the creation of a new session
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid: string, requestId: string, fieldUuid?: string, force?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseStartWizardSessionDevicesDeviceUuidSessionPost>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid, requestId, fieldUuid, force, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Stop Wizard Session
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DevicesApi - factory interface
 * @export
 */
export const DevicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Clear Wizard Session
         * @param {string} deviceUuid 
         * @param {string} xExpiryTimestamp 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid: string, xExpiryTimestamp: string, options?: any): AxiosPromise<void> {
            return localVarFp.clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid, xExpiryTimestamp, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deploy Automatictv
         * @param {string} deviceUuid 
         * @param {Upgrade} [upgrade] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid: string, upgrade?: Upgrade, options?: any): AxiosPromise<DeviceDeploymentDTO> {
            return localVarFp.deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid, upgrade, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Deploy Remote Support
         * @param {string} deviceUuid 
         * @param {RemoteSupportDTO} remoteSupportDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid: string, remoteSupportDTO: RemoteSupportDTO, options?: any): AxiosPromise<DeviceDeploymentDTO> {
            return localVarFp.deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid, remoteSupportDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Deployment
         * @param {string} deviceUuid 
         * @param {string} deploymentUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid: string, deploymentUuid: string, options?: any): AxiosPromise<DeviceDeploymentDTO> {
            return localVarFp.getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid, deploymentUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Device Detail
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDeviceDetailDevicesDeviceUuidGet(deviceUuid: string, options?: any): AxiosPromise<DeviceWithCamerasDTO> {
            return localVarFp.getDeviceDetailDevicesDeviceUuidGet(deviceUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Devices List
         * @param {SearchParam} [search] 
         * @param {FilterByStatus} [status] List of status to filter the devices.
         * @param {DevicesSortOptions} [orderBy] 
         * @param {SortDirectionOptions} [orderDir] 
         * @param {number} [page] 
         * @param {number} [size] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDevicesListDevicesGet(search?: SearchParam, status?: FilterByStatus, orderBy?: DevicesSortOptions, orderDir?: SortDirectionOptions, page?: number, size?: number, options?: any): AxiosPromise<PageDeviceDTO> {
            return localVarFp.getDevicesListDevicesGet(search, status, orderBy, orderDir, page, size, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Ocr Cameras
         * @param {string} deviceUuid 
         * @param {boolean} [onlyActive] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid: string, onlyActive?: boolean, xWizardSessionToken?: string, options?: any): AxiosPromise<OcrCamerasResponseDTO> {
            return localVarFp.getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid, onlyActive, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary License Device
         * @param {string} deviceUuid 
         * @param {LicenseDeviceDTO} licenseDeviceDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid: string, licenseDeviceDTO: LicenseDeviceDTO, options?: any): AxiosPromise<ResponseLicenseDeviceDevicesDeviceUuidLicensePost> {
            return localVarFp.licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid, licenseDeviceDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDTO} editDeviceDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigDevicesDeviceUuidPut(deviceUuid: string, editDeviceDTO: EditDeviceDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.setDeviceConfigDevicesDeviceUuidPut(deviceUuid, editDeviceDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Start Wizard Session
         * @param {string} deviceUuid 
         * @param {string} requestId Request identifier to create a pull if requests timeout
         * @param {string} [fieldUuid] Field UUID to start the session
         * @param {boolean} [force] If true, it will force the creation of a new session
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid: string, requestId: string, fieldUuid?: string, force?: boolean, xWizardSessionToken?: string, options?: any): AxiosPromise<ResponseStartWizardSessionDevicesDeviceUuidSessionPost> {
            return localVarFp.startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid, requestId, fieldUuid, force, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Stop Wizard Session
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevicesApi - object-oriented interface
 * @export
 * @class DevicesApi
 * @extends {BaseAPI}
 */
export class DevicesApi extends BaseAPI {
    /**
     * 
     * @summary Clear Wizard Session
     * @param {string} deviceUuid 
     * @param {string} xExpiryTimestamp 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid: string, xExpiryTimestamp: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).clearWizardSessionDevicesDeviceUuidSessionClearDelete(deviceUuid, xExpiryTimestamp, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deploy Automatictv
     * @param {string} deviceUuid 
     * @param {Upgrade} [upgrade] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid: string, upgrade?: Upgrade, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).deployAutomatictvDevicesDeviceUuidDeployPost(deviceUuid, upgrade, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Deploy Remote Support
     * @param {string} deviceUuid 
     * @param {RemoteSupportDTO} remoteSupportDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid: string, remoteSupportDTO: RemoteSupportDTO, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).deployRemoteSupportDevicesDeviceUuidRemoteSupportPost(deviceUuid, remoteSupportDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Deployment
     * @param {string} deviceUuid 
     * @param {string} deploymentUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid: string, deploymentUuid: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).getDeploymentDevicesDeviceUuidDeployDeploymentUuidGet(deviceUuid, deploymentUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Device Detail
     * @param {string} deviceUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public getDeviceDetailDevicesDeviceUuidGet(deviceUuid: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).getDeviceDetailDevicesDeviceUuidGet(deviceUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Devices List
     * @param {SearchParam} [search] 
     * @param {FilterByStatus} [status] List of status to filter the devices.
     * @param {DevicesSortOptions} [orderBy] 
     * @param {SortDirectionOptions} [orderDir] 
     * @param {number} [page] 
     * @param {number} [size] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public getDevicesListDevicesGet(search?: SearchParam, status?: FilterByStatus, orderBy?: DevicesSortOptions, orderDir?: SortDirectionOptions, page?: number, size?: number, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).getDevicesListDevicesGet(search, status, orderBy, orderDir, page, size, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Ocr Cameras
     * @param {string} deviceUuid 
     * @param {boolean} [onlyActive] 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid: string, onlyActive?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).getOcrCamerasDevicesDeviceUuidOcrCamerasGet(deviceUuid, onlyActive, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary License Device
     * @param {string} deviceUuid 
     * @param {LicenseDeviceDTO} licenseDeviceDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid: string, licenseDeviceDTO: LicenseDeviceDTO, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).licenseDeviceDevicesDeviceUuidLicensePost(deviceUuid, licenseDeviceDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Device Config
     * @param {string} deviceUuid 
     * @param {EditDeviceDTO} editDeviceDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public setDeviceConfigDevicesDeviceUuidPut(deviceUuid: string, editDeviceDTO: EditDeviceDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).setDeviceConfigDevicesDeviceUuidPut(deviceUuid, editDeviceDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Device Config
     * @param {string} deviceUuid 
     * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Start Wizard Session
     * @param {string} deviceUuid 
     * @param {string} requestId Request identifier to create a pull if requests timeout
     * @param {string} [fieldUuid] Field UUID to start the session
     * @param {boolean} [force] If true, it will force the creation of a new session
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid: string, requestId: string, fieldUuid?: string, force?: boolean, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).startWizardSessionDevicesDeviceUuidSessionPost(deviceUuid, requestId, fieldUuid, force, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Stop Wizard Session
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevicesApi
     */
    public stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return DevicesApiFp(this.configuration).stopWizardSessionDevicesDeviceUuidSessionDelete(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * FieldsApi - axios parameter creator
 * @export
 */
export const FieldsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete Field
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete: async (deviceUuid: string, fieldUuid: string, force?: boolean, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete', 'fieldUuid', fieldUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (force !== undefined) {
                localVarQueryParameter['force'] = force;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet: async (deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet: async (deviceUuid: string, fieldUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {EditFieldConfigurationDTO} editFieldConfigurationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut: async (deviceUuid: string, fieldUuid: string, editFieldConfigurationDTO: EditFieldConfigurationDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut', 'fieldUuid', fieldUuid)
            // verify required parameter 'editFieldConfigurationDTO' is not null or undefined
            assertParamExists('setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut', 'editFieldConfigurationDTO', editFieldConfigurationDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editFieldConfigurationDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost: async (deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'setFieldConfig' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'setFieldConfig', setFieldConfig)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setFieldConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldsApi - functional programming interface
 * @export
 */
export const FieldsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FieldsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete Field
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid: string, fieldUuid: string, force?: boolean, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid, fieldUuid, force, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceProConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {EditFieldConfigurationDTO} editFieldConfigurationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid: string, fieldUuid: string, editFieldConfigurationDTO: EditFieldConfigurationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid, fieldUuid, editFieldConfigurationDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceProConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FieldsApi - factory interface
 * @export
 */
export const FieldsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FieldsApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete Field
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {boolean} [force] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid: string, fieldUuid: string, force?: boolean, options?: any): AxiosPromise<void> {
            return localVarFp.deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid, fieldUuid, force, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldConfigurationDTO> {
            return localVarFp.getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: any): AxiosPromise<DeviceProConfigurationDTO> {
            return localVarFp.getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {EditFieldConfigurationDTO} editFieldConfigurationDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid: string, fieldUuid: string, editFieldConfigurationDTO: EditFieldConfigurationDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldConfigurationDTO> {
            return localVarFp.setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid, fieldUuid, editFieldConfigurationDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: any): AxiosPromise<DeviceProConfigurationDTO> {
            return localVarFp.setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldsApi - object-oriented interface
 * @export
 * @class FieldsApi
 * @extends {BaseAPI}
 */
export class FieldsApi extends BaseAPI {
    /**
     * 
     * @summary Delete Field
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {boolean} [force] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid: string, fieldUuid: string, force?: boolean, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).deleteFieldDevicesDeviceUuidFieldsFieldUuidDelete(deviceUuid, fieldUuid, force, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).getFieldConfigurationDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {EditFieldConfigurationDTO} editFieldConfigurationDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid: string, fieldUuid: string, editFieldConfigurationDTO: EditFieldConfigurationDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).setFieldConfigurationDevicesDeviceUuidFieldsFieldUuidPut(deviceUuid, fieldUuid, editFieldConfigurationDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {SetFieldConfig} setFieldConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FieldsApi
     */
    public setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: AxiosRequestConfig) {
        return FieldsApiFp(this.configuration).setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OptionsApi - axios parameter creator
 * @export
 */
export const OptionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all the information needed to print the left side of the calibration page. An image with all the lines, the dimension of the field and a list of points with the ID
         * @summary Get Calibration Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet: async (deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/options/fields/{field_uuid}/calibration/{sport_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the options available with their respective choices for the camera settings form (2nd step)
         * @summary Get Camera Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraOptionsDevicesDeviceUuidOptionsCamerasGet: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getCameraOptionsDevicesDeviceUuidOptionsCamerasGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/cameras/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraTypesOptionsCameraTypesGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/options/camera_types`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get protocols and qualities available for the destinations form (5th step)
         * @summary Get Destination Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/destinations/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the options available with all the options for field details form (1st step)
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsDevicesDeviceUuidOptionsDetailsGet: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldOptionsDevicesDeviceUuidOptionsDetailsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/details/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet: async (deviceUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/pro/devices/{device_uuid}/options/details/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Graphic Plugins
         * @param {string} deviceUuid 
         * @param {TypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet: async (deviceUuid: string, type?: TypeEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/smart_scoreboard/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Graphic Template
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet: async (deviceUuid: string, sportUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/options/smart_scoreboard/template/{sport_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the sports available (configured) with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/preset_settings/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all the modes and styles available, for specific sport, with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Sport Options
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet: async (deviceUuid: string, sportUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'sportUuid' is not null or undefined
            assertParamExists('getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet', 'sportUuid', sportUuid)
            const localVarPath = `/devices/{device_uuid}/options/preset_settings/{sport_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"sport_uuid"}}`, encodeURIComponent(String(sportUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the list of sport groups with all the sports and sportfields
         * @summary Get Sports
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsDevicesDeviceUuidOptionsSportsGet: async (deviceUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getSportsDevicesDeviceUuidOptionsSportsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/devices/{device_uuid}/options/sports/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OptionsApi - functional programming interface
 * @export
 */
export const OptionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OptionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Get all the information needed to print the left side of the calibration page. An image with all the lines, the dimension of the field and a list of points with the ID
         * @summary Get Calibration Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CalibrationOptionsDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the options available with their respective choices for the camera settings form (2nd step)
         * @summary Get Camera Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCameraTypesOptionsCameraTypesGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCameraTypesOptionsCameraTypesGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get protocols and qualities available for the destinations form (5th step)
         * @summary Get Destination Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the options available with all the options for field details form (1st step)
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Graphic Plugins
         * @param {string} deviceUuid 
         * @param {TypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid: string, type?: TypeEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid, type, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Graphic Template
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid: string, sportUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SmartScoreboardTemplate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid, sportUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the sports available (configured) with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get all the modes and styles available, for specific sport, with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Sport Options
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the list of sport groups with all the sports and sportfields
         * @summary Get Sports
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SportGroupDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OptionsApi - factory interface
 * @export
 */
export const OptionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OptionsApiFp(configuration)
    return {
        /**
         * Get all the information needed to print the left side of the calibration page. An image with all the lines, the dimension of the field and a list of points with the ID
         * @summary Get Calibration Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<CalibrationOptionsDTO> {
            return localVarFp.getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the options available with their respective choices for the camera settings form (2nd step)
         * @summary Get Camera Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Camera Types
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCameraTypesOptionsCameraTypesGet(options?: any): AxiosPromise<Array<string>> {
            return localVarFp.getCameraTypesOptionsCameraTypesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Get protocols and qualities available for the destinations form (5th step)
         * @summary Get Destination Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the options available with all the options for field details form (1st step)
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Graphic Plugins
         * @param {string} deviceUuid 
         * @param {TypeEnum} [type] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid: string, type?: TypeEnum, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid, type, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Graphic Template
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid: string, sportUuid: string, options?: any): AxiosPromise<SmartScoreboardTemplate> {
            return localVarFp.getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid, sportUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the sports available (configured) with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Options
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all the modes and styles available, for specific sport, with their respective choices for the preset settings form (1st step)
         * @summary Get Preset Sport Options
         * @param {string} deviceUuid 
         * @param {string} sportUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the list of sport groups with all the sports and sportfields
         * @summary Get Sports
         * @param {string} deviceUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<Array<SportGroupDTO>> {
            return localVarFp.getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OptionsApi - object-oriented interface
 * @export
 * @class OptionsApi
 * @extends {BaseAPI}
 */
export class OptionsApi extends BaseAPI {
    /**
     * Get all the information needed to print the left side of the calibration page. An image with all the lines, the dimension of the field and a list of points with the ID
     * @summary Get Calibration Options
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} sportUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid: string, fieldUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getCalibrationOptionsDevicesDeviceUuidOptionsFieldsFieldUuidCalibrationSportUuidGet(deviceUuid, fieldUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the options available with their respective choices for the camera settings form (2nd step)
     * @summary Get Camera Options
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getCameraOptionsDevicesDeviceUuidOptionsCamerasGet(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Camera Types
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getCameraTypesOptionsCameraTypesGet(options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getCameraTypesOptionsCameraTypesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get protocols and qualities available for the destinations form (5th step)
     * @summary Get Destination Options
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getDestinationOptionsDevicesDeviceUuidOptionsDestinationsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the options available with all the options for field details form (1st step)
     * @summary Get Field Options
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getFieldOptionsDevicesDeviceUuidOptionsDetailsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Field Options
     * @param {string} deviceUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Graphic Plugins
     * @param {string} deviceUuid 
     * @param {TypeEnum} [type] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid: string, type?: TypeEnum, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getGraphicPluginsDevicesDeviceUuidOptionsSmartScoreboardGet(deviceUuid, type, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Graphic Template
     * @param {string} deviceUuid 
     * @param {string} sportUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid: string, sportUuid: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getGraphicTemplateDevicesDeviceUuidOptionsSmartScoreboardTemplateSportUuidGet(deviceUuid, sportUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the sports available (configured) with their respective choices for the preset settings form (1st step)
     * @summary Get Preset Options
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getPresetOptionsDevicesDeviceUuidOptionsPresetSettingsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all the modes and styles available, for specific sport, with their respective choices for the preset settings form (1st step)
     * @summary Get Preset Sport Options
     * @param {string} deviceUuid 
     * @param {string} sportUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid: string, sportUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getPresetSportOptionsDevicesDeviceUuidOptionsPresetSettingsSportUuidGet(deviceUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the list of sport groups with all the sports and sportfields
     * @summary Get Sports
     * @param {string} deviceUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OptionsApi
     */
    public getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return OptionsApiFp(this.configuration).getSportsDevicesDeviceUuidOptionsSportsGet(deviceUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * OrganizationsApi - axios parameter creator
 * @export
 */
export const OrganizationsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOrganizationsGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Pair Device
         * @param {string} organizationUuid 
         * @param {DeviceRegisterDTO} deviceRegisterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pairDeviceOrganizationsOrganizationUuidPairDevicePost: async (organizationUuid: string, deviceRegisterDTO: DeviceRegisterDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationUuid' is not null or undefined
            assertParamExists('pairDeviceOrganizationsOrganizationUuidPairDevicePost', 'organizationUuid', organizationUuid)
            // verify required parameter 'deviceRegisterDTO' is not null or undefined
            assertParamExists('pairDeviceOrganizationsOrganizationUuidPairDevicePost', 'deviceRegisterDTO', deviceRegisterDTO)
            const localVarPath = `/organizations/{organization_uuid}/pair_device/`
                .replace(`{${"organization_uuid"}}`, encodeURIComponent(String(organizationUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceRegisterDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationsApi - functional programming interface
 * @export
 */
export const OrganizationsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganizationsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOrganizationsGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOrganizationsGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Pair Device
         * @param {string} organizationUuid 
         * @param {DeviceRegisterDTO} deviceRegisterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid: string, deviceRegisterDTO: DeviceRegisterDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceRegisterResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid, deviceRegisterDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganizationsApi - factory interface
 * @export
 */
export const OrganizationsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganizationsApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Organizations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOrganizationsGet(options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getOrganizationsOrganizationsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Pair Device
         * @param {string} organizationUuid 
         * @param {DeviceRegisterDTO} deviceRegisterDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid: string, deviceRegisterDTO: DeviceRegisterDTO, options?: any): AxiosPromise<DeviceRegisterResponseDTO> {
            return localVarFp.pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid, deviceRegisterDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * OrganizationsApi - object-oriented interface
 * @export
 * @class OrganizationsApi
 * @extends {BaseAPI}
 */
export class OrganizationsApi extends BaseAPI {
    /**
     * 
     * @summary Get Organizations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public getOrganizationsOrganizationsGet(options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).getOrganizationsOrganizationsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Pair Device
     * @param {string} organizationUuid 
     * @param {DeviceRegisterDTO} deviceRegisterDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationsApi
     */
    public pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid: string, deviceRegisterDTO: DeviceRegisterDTO, options?: AxiosRequestConfig) {
        return OrganizationsApiFp(this.configuration).pairDeviceOrganizationsOrganizationUuidPairDevicePost(organizationUuid, deviceRegisterDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * PresetsApi - axios parameter creator
 * @export
 */
export const PresetsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check Preset Name Availability
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} name 
         * @param {PresetUuid} [presetUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet: async (deviceUuid: string, fieldUuid: string, name: string, presetUuid?: PresetUuid, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'name' is not null or undefined
            assertParamExists('checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet', 'name', name)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/check_preset_name_availability`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (presetUuid !== undefined) {
                localVarQueryParameter['preset_uuid'] = presetUuid;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete: async (deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete', 'presetUuid', presetUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to create a copy of a preset automatically. It can accept a name in the payload, if no payload provided we are going to generate one from the original name.
         * @summary Duplicate Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {DuplicatePresetDTO} duplicatePresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost: async (deviceUuid: string, fieldUuid: string, presetUuid: string, duplicatePresetDTO: DuplicatePresetDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost', 'presetUuid', presetUuid)
            // verify required parameter 'duplicatePresetDTO' is not null or undefined
            assertParamExists('duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost', 'duplicatePresetDTO', duplicatePresetDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/duplicate/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(duplicatePresetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'presetUuid', presetUuid)
            // verify required parameter 'presetProOverlaysDTO' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'presetProOverlaysDTO', presetProOverlaysDTO)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presetProOverlaysDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'presetUuid', presetUuid)
            // verify required parameter 'favoritePreset' is not null or undefined
            assertParamExists('favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'favoritePreset', favoritePreset)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/favorite/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoritePreset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'presetUuid', presetUuid)
            // verify required parameter 'favoritePreset' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'favoritePreset', favoritePreset)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/favorite/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoritePreset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'presetUuid', presetUuid)
            // verify required parameter 'feedName' is not null or undefined
            assertParamExists('getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'feedName', feedName)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/feed/{feed_name}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)))
                .replace(`{${"feed_name"}}`, encodeURIComponent(String(feedName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'presetUuid', presetUuid)
            // verify required parameter 'feedName' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'feedName', feedName)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/feed/{feed_name}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)))
                .replace(`{${"feed_name"}}`, encodeURIComponent(String(feedName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid1} [sportUuid] The UUID sport reference that we return after you create a new sport from the API.
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid1, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'presetUuid', presetUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/graphics_configuration`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (sportUuid !== undefined) {
                localVarQueryParameter['sport_uuid'] = sportUuid;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/graphics_configuration`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (sportUuid !== undefined) {
                localVarQueryParameter['sport_uuid'] = sportUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Image From Camera
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} cameraUuid 
         * @param {SportUuid} [sportUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, cameraUuid: string, sportUuid?: SportUuid, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet', 'presetUuid', presetUuid)
            // verify required parameter 'cameraUuid' is not null or undefined
            assertParamExists('getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet', 'cameraUuid', cameraUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/camera/{camera_uuid}`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)))
                .replace(`{${"camera_uuid"}}`, encodeURIComponent(String(cameraUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (sportUuid !== undefined) {
                localVarQueryParameter['sport_uuid'] = sportUuid;
            }

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Image Resource
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} imageUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, imageUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet', 'presetUuid', presetUuid)
            // verify required parameter 'imageUuid' is not null or undefined
            assertParamExists('getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet', 'imageUuid', imageUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/image/{image_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)))
                .replace(`{${"image_uuid"}}`, encodeURIComponent(String(imageUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'presetUuid', presetUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/organizations_options`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/organizations_options`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'presetUuid', presetUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet: async (deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet: async (deviceUuid: string, fieldUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to generate a preset skaffold with an assigned uuid that will be used for the following tasks:  - edit camera settings  - get feed image  - upload images  If we receive a request to initialize a new endpoint and there is an unsaved skaffold in DB, we are going to delete the existing preset and all the images and calibrations related to that preset and finally recreate a new one.  Also, this endpoint should include a payload with the sport and production style, for this reason we should call this endpoint after the step 1 of the \"new production preset\" workflow.  Optionally, we can pass all the rest of information about the preset if we want to set the parameters to specific ones, for example, if we are editing an existing preset, we should pass the uuid at least, if we are coming back from future steps, we should pass all the fields already set.
         * @summary Init Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {InitPresetDTO} initPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost: async (deviceUuid: string, fieldUuid: string, initPresetDTO: InitPresetDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'initPresetDTO' is not null or undefined
            assertParamExists('initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost', 'initPresetDTO', initPresetDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(initPresetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to save a preset skaffold and make it available to use or to update an existing preset
         * @summary Save Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {EditFieldPresetDTO} editFieldPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut: async (deviceUuid: string, fieldUuid: string, presetUuid: string, editFieldPresetDTO: EditFieldPresetDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut', 'presetUuid', presetUuid)
            // verify required parameter 'editFieldPresetDTO' is not null or undefined
            assertParamExists('savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut', 'editFieldPresetDTO', editFieldPresetDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editFieldPresetDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'presetUuid', presetUuid)
            // verify required parameter 'transferPresetWithDTO' is not null or undefined
            assertParamExists('transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'transferPresetWithDTO', transferPresetWithDTO)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/transfer/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferPresetWithDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'presetUuid', presetUuid)
            // verify required parameter 'transferPresetWithDTO' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'transferPresetWithDTO', transferPresetWithDTO)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/transfer/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferPresetWithDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Unload Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost: async (deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost', 'presetUuid', presetUuid)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/unload`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Camera Setting
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {ChangeSetting} changeSetting 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, changeSetting: ChangeSetting, xWizardSessionToken?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch', 'presetUuid', presetUuid)
            // verify required parameter 'changeSetting' is not null or undefined
            assertParamExists('updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch', 'changeSetting', changeSetting)
            const localVarPath = `/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/camera_setting/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (xWizardSessionToken != null) {
                localVarHeaderParameter['x-wizard-session-token'] = String(xWizardSessionToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changeSetting, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PresetsApi - functional programming interface
 * @export
 */
export const PresetsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PresetsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check Preset Name Availability
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} name 
         * @param {PresetUuid} [presetUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid: string, fieldUuid: string, name: string, presetUuid?: PresetUuid, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid, fieldUuid, name, presetUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Delete Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to create a copy of a preset automatically. It can accept a name in the payload, if no payload provided we are going to generate one from the original name.
         * @summary Duplicate Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {DuplicatePresetDTO} duplicatePresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid: string, fieldUuid: string, presetUuid: string, duplicatePresetDTO: DuplicatePresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldPresetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid, fieldUuid, presetUuid, duplicatePresetDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseDevicePresetProDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid1} [sportUuid] The UUID sport reference that we return after you create a new sport from the API.
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid1, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceOCROptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceOCROptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Image From Camera
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} cameraUuid 
         * @param {SportUuid} [sportUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, cameraUuid: string, sportUuid?: SportUuid, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid, fieldUuid, presetUuid, cameraUuid, sportUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Image Resource
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} imageUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, imageUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid, fieldUuid, presetUuid, imageUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseDevicePresetProDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldPresetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FieldPresetDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseDevicePresetProDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to generate a preset skaffold with an assigned uuid that will be used for the following tasks:  - edit camera settings  - get feed image  - upload images  If we receive a request to initialize a new endpoint and there is an unsaved skaffold in DB, we are going to delete the existing preset and all the images and calibrations related to that preset and finally recreate a new one.  Also, this endpoint should include a payload with the sport and production style, for this reason we should call this endpoint after the step 1 of the \"new production preset\" workflow.  Optionally, we can pass all the rest of information about the preset if we want to set the parameters to specific ones, for example, if we are editing an existing preset, we should pass the uuid at least, if we are coming back from future steps, we should pass all the fields already set.
         * @summary Init Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {InitPresetDTO} initPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid: string, fieldUuid: string, initPresetDTO: InitPresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldPresetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid, fieldUuid, initPresetDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to save a preset skaffold and make it available to use or to update an existing preset
         * @summary Save Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {EditFieldPresetDTO} editFieldPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid: string, fieldUuid: string, presetUuid: string, editFieldPresetDTO: EditFieldPresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FieldPresetDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid, fieldUuid, presetUuid, editFieldPresetDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Unload Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Update Camera Setting
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {ChangeSetting} changeSetting 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, changeSetting: ChangeSetting, xWizardSessionToken?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StatusResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid, fieldUuid, presetUuid, changeSetting, xWizardSessionToken, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PresetsApi - factory interface
 * @export
 */
export const PresetsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PresetsApiFp(configuration)
    return {
        /**
         * 
         * @summary Check Preset Name Availability
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} name 
         * @param {PresetUuid} [presetUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid: string, fieldUuid: string, name: string, presetUuid?: PresetUuid, xWizardSessionToken?: string, options?: any): AxiosPromise<boolean> {
            return localVarFp.checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid, fieldUuid, name, presetUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to create a copy of a preset automatically. It can accept a name in the payload, if no payload provided we are going to generate one from the original name.
         * @summary Duplicate Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {DuplicatePresetDTO} duplicatePresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid: string, fieldUuid: string, presetUuid: string, duplicatePresetDTO: DuplicatePresetDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldPresetDTO> {
            return localVarFp.duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid, fieldUuid, presetUuid, duplicatePresetDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: any): AxiosPromise<BaseDevicePresetProDTO> {
            return localVarFp.editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, xWizardSessionToken?: string, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, xWizardSessionToken?: string, options?: any): AxiosPromise<Image> {
            return localVarFp.getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: any): AxiosPromise<Image> {
            return localVarFp.getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid1} [sportUuid] The UUID sport reference that we return after you create a new sport from the API.
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid1, xWizardSessionToken?: string, options?: any): AxiosPromise<DeviceOCROptions> {
            return localVarFp.getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: any): AxiosPromise<DeviceOCROptions> {
            return localVarFp.getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Image From Camera
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} cameraUuid 
         * @param {SportUuid} [sportUuid] 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, cameraUuid: string, sportUuid?: SportUuid, xWizardSessionToken?: string, options?: any): AxiosPromise<Image> {
            return localVarFp.getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid, fieldUuid, presetUuid, cameraUuid, sportUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Image Resource
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} imageUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, imageUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<Image> {
            return localVarFp.getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid, fieldUuid, presetUuid, imageUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<OrganizationOptions> {
            return localVarFp.getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: any): AxiosPromise<OrganizationOptions> {
            return localVarFp.getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: any): AxiosPromise<BaseDevicePresetProDTO> {
            return localVarFp.getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldPresetDTO> {
            return localVarFp.getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<Array<FieldPresetDTO>> {
            return localVarFp.getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: any): AxiosPromise<Array<BaseDevicePresetProDTO>> {
            return localVarFp.getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to generate a preset skaffold with an assigned uuid that will be used for the following tasks:  - edit camera settings  - get feed image  - upload images  If we receive a request to initialize a new endpoint and there is an unsaved skaffold in DB, we are going to delete the existing preset and all the images and calibrations related to that preset and finally recreate a new one.  Also, this endpoint should include a payload with the sport and production style, for this reason we should call this endpoint after the step 1 of the \"new production preset\" workflow.  Optionally, we can pass all the rest of information about the preset if we want to set the parameters to specific ones, for example, if we are editing an existing preset, we should pass the uuid at least, if we are coming back from future steps, we should pass all the fields already set.
         * @summary Init Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {InitPresetDTO} initPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid: string, fieldUuid: string, initPresetDTO: InitPresetDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldPresetDTO> {
            return localVarFp.initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid, fieldUuid, initPresetDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to save a preset skaffold and make it available to use or to update an existing preset
         * @summary Save Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {EditFieldPresetDTO} editFieldPresetDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid: string, fieldUuid: string, presetUuid: string, editFieldPresetDTO: EditFieldPresetDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<FieldPresetDTO> {
            return localVarFp.savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid, fieldUuid, presetUuid, editFieldPresetDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, xWizardSessionToken?: string, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Unload Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: any): AxiosPromise<void> {
            return localVarFp.unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Camera Setting
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {ChangeSetting} changeSetting 
         * @param {string} [xWizardSessionToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, changeSetting: ChangeSetting, xWizardSessionToken?: string, options?: any): AxiosPromise<StatusResponse> {
            return localVarFp.updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid, fieldUuid, presetUuid, changeSetting, xWizardSessionToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PresetsApi - object-oriented interface
 * @export
 * @class PresetsApi
 * @extends {BaseAPI}
 */
export class PresetsApi extends BaseAPI {
    /**
     * 
     * @summary Check Preset Name Availability
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} name 
     * @param {PresetUuid} [presetUuid] 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid: string, fieldUuid: string, name: string, presetUuid?: PresetUuid, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).checkPresetNameAvailabilityDevicesDeviceUuidFieldsFieldUuidPresetsCheckPresetNameAvailabilityGet(deviceUuid, fieldUuid, name, presetUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).deletePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDelete(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to create a copy of a preset automatically. It can accept a name in the payload, if no payload provided we are going to generate one from the original name.
     * @summary Duplicate Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {DuplicatePresetDTO} duplicatePresetDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid: string, fieldUuid: string, presetUuid: string, duplicatePresetDTO: DuplicatePresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).duplicatePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidDuplicatePost(deviceUuid, fieldUuid, presetUuid, duplicatePresetDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Edit Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to favorite a preset or remove it from favorited presets
     * @summary Favorite Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FavoritePreset} favoritePreset 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).favoritePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to favorite a preset or remove it from favorited presets
     * @summary Favorite Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FavoritePreset} favoritePreset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Feed Image
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FeedNameEnum} feedName 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getFeedImageDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Feed Image
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FeedNameEnum} feedName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the whole graphics configuration filtered by the preset.
     * @summary Get Graphics By Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {SportUuid1} [sportUuid] The UUID sport reference that we return after you create a new sport from the API.
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid1, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getGraphicsByPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the whole graphics configuration filtered by the preset.
     * @summary Get Graphics By Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Image From Camera
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} cameraUuid 
     * @param {SportUuid} [sportUuid] 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, cameraUuid: string, sportUuid?: SportUuid, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getImageFromCameraDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraCameraUuidGet(deviceUuid, fieldUuid, presetUuid, cameraUuid, sportUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Image Resource
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} imageUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, imageUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getImageResourceDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidImageImageUuidGet(deviceUuid, fieldUuid, presetUuid, imageUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations Options
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getOrganizationsOptionsDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations Options
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Preset Details
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Presets
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getPresetsDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Presets
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to generate a preset skaffold with an assigned uuid that will be used for the following tasks:  - edit camera settings  - get feed image  - upload images  If we receive a request to initialize a new endpoint and there is an unsaved skaffold in DB, we are going to delete the existing preset and all the images and calibrations related to that preset and finally recreate a new one.  Also, this endpoint should include a payload with the sport and production style, for this reason we should call this endpoint after the step 1 of the \"new production preset\" workflow.  Optionally, we can pass all the rest of information about the preset if we want to set the parameters to specific ones, for example, if we are editing an existing preset, we should pass the uuid at least, if we are coming back from future steps, we should pass all the fields already set.
     * @summary Init Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {InitPresetDTO} initPresetDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid: string, fieldUuid: string, initPresetDTO: InitPresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).initPresetDevicesDeviceUuidFieldsFieldUuidPresetsPost(deviceUuid, fieldUuid, initPresetDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to save a preset skaffold and make it available to use or to update an existing preset
     * @summary Save Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {EditFieldPresetDTO} editFieldPresetDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid: string, fieldUuid: string, presetUuid: string, editFieldPresetDTO: EditFieldPresetDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).savePresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPut(deviceUuid, fieldUuid, presetUuid, editFieldPresetDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {TransferPresetWithDTO} transferPresetWithDTO 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).transferPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {TransferPresetWithDTO} transferPresetWithDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Unload Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid: string, fieldUuid: string, presetUuid: string, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).unloadPresetDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidUnloadPost(deviceUuid, fieldUuid, presetUuid, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Camera Setting
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {ChangeSetting} changeSetting 
     * @param {string} [xWizardSessionToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PresetsApi
     */
    public updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, changeSetting: ChangeSetting, xWizardSessionToken?: string, options?: AxiosRequestConfig) {
        return PresetsApiFp(this.configuration).updateCameraSettingDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidCameraSettingPatch(deviceUuid, fieldUuid, presetUuid, changeSetting, xWizardSessionToken, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * ProBroadcastApi - axios parameter creator
 * @export
 */
export const ProBroadcastApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'presetUuid', presetUuid)
            // verify required parameter 'presetProOverlaysDTO' is not null or undefined
            assertParamExists('editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch', 'presetProOverlaysDTO', presetProOverlaysDTO)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(presetProOverlaysDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'presetUuid', presetUuid)
            // verify required parameter 'favoritePreset' is not null or undefined
            assertParamExists('favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch', 'favoritePreset', favoritePreset)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/favorite/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(favoritePreset, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'presetUuid', presetUuid)
            // verify required parameter 'feedName' is not null or undefined
            assertParamExists('getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet', 'feedName', feedName)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/feed/{feed_name}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)))
                .replace(`{${"feed_name"}}`, encodeURIComponent(String(feedName)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet: async (deviceUuid: string, fieldUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet: async (deviceUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet', 'deviceUuid', deviceUuid)
            const localVarPath = `/pro/devices/{device_uuid}/options/details/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/graphics_configuration`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (sportUuid !== undefined) {
                localVarQueryParameter['sport_uuid'] = sportUuid;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/organizations_options`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet: async (deviceUuid: string, fieldUuid: string, presetUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet', 'presetUuid', presetUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet: async (deviceUuid: string, fieldUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet', 'fieldUuid', fieldUuid)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigProDevicesDeviceUuidPut: async (deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setDeviceConfigProDevicesDeviceUuidPut', 'deviceUuid', deviceUuid)
            // verify required parameter 'editDeviceDetailsDTO' is not null or undefined
            assertParamExists('setDeviceConfigProDevicesDeviceUuidPut', 'editDeviceDetailsDTO', editDeviceDetailsDTO)
            const localVarPath = `/pro/devices/{device_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(editDeviceDetailsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost: async (deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'fieldUuid', fieldUuid)
            // verify required parameter 'setFieldConfig' is not null or undefined
            assertParamExists('setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost', 'setFieldConfig', setFieldConfig)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setFieldConfig, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch: async (deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'deviceUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'deviceUuid', deviceUuid)
            // verify required parameter 'fieldUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'fieldUuid', fieldUuid)
            // verify required parameter 'presetUuid' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'presetUuid', presetUuid)
            // verify required parameter 'transferPresetWithDTO' is not null or undefined
            assertParamExists('transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch', 'transferPresetWithDTO', transferPresetWithDTO)
            const localVarPath = `/pro/devices/{device_uuid}/fields/{field_uuid}/presets/{preset_uuid}/transfer/`
                .replace(`{${"device_uuid"}}`, encodeURIComponent(String(deviceUuid)))
                .replace(`{${"field_uuid"}}`, encodeURIComponent(String(fieldUuid)))
                .replace(`{${"preset_uuid"}}`, encodeURIComponent(String(presetUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(transferPresetWithDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProBroadcastApi - functional programming interface
 * @export
 */
export const ProBroadcastApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProBroadcastApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseDevicePresetProDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Image>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceProConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: OptionDetails; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceOCROptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationOptions>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseDevicePresetProDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseDevicePresetProDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeviceProConfigurationDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DefaultResponseDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ProBroadcastApi - factory interface
 * @export
 */
export const ProBroadcastApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProBroadcastApiFp(configuration)
    return {
        /**
         * 
         * @summary Edit Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: any): AxiosPromise<BaseDevicePresetProDTO> {
            return localVarFp.editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Endpoint to favorite a preset or remove it from favorited presets
         * @summary Favorite Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FavoritePreset} favoritePreset 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Feed Image
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {FeedNameEnum} feedName 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: any): AxiosPromise<Image> {
            return localVarFp.getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: any): AxiosPromise<DeviceProConfigurationDTO> {
            return localVarFp.getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Field Options
         * @param {string} deviceUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: any): AxiosPromise<{ [key: string]: OptionDetails; }> {
            return localVarFp.getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * Get the whole graphics configuration filtered by the preset.
         * @summary Get Graphics By Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: any): AxiosPromise<DeviceOCROptions> {
            return localVarFp.getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organizations Options
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: any): AxiosPromise<OrganizationOptions> {
            return localVarFp.getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Preset Details
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: any): AxiosPromise<BaseDevicePresetProDTO> {
            return localVarFp.getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Presets
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: any): AxiosPromise<Array<BaseDevicePresetProDTO>> {
            return localVarFp.getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Device Config
         * @param {string} deviceUuid 
         * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Field Configuration
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {SetFieldConfig} setFieldConfig 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: any): AxiosPromise<DeviceProConfigurationDTO> {
            return localVarFp.setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Transfer Preset
         * @param {string} deviceUuid 
         * @param {string} fieldUuid 
         * @param {string} presetUuid 
         * @param {TransferPresetWithDTO} transferPresetWithDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: any): AxiosPromise<DefaultResponseDTO> {
            return localVarFp.transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProBroadcastApi - object-oriented interface
 * @export
 * @class ProBroadcastApi
 * @extends {BaseAPI}
 */
export class ProBroadcastApi extends BaseAPI {
    /**
     * 
     * @summary Edit Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {PresetProOverlaysDTO} presetProOverlaysDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, presetProOverlaysDTO: PresetProOverlaysDTO, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).editPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidPatch(deviceUuid, fieldUuid, presetUuid, presetProOverlaysDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Endpoint to favorite a preset or remove it from favorited presets
     * @summary Favorite Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FavoritePreset} favoritePreset 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid: string, fieldUuid: string, presetUuid: string, favoritePreset: FavoritePreset, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).favoritePresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFavoritePatch(deviceUuid, fieldUuid, presetUuid, favoritePreset, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Feed Image
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {FeedNameEnum} feedName 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid: string, fieldUuid: string, presetUuid: string, feedName: FeedNameEnum, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getFeedImageProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidFeedFeedNameGet(deviceUuid, fieldUuid, presetUuid, feedName, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidGet(deviceUuid, fieldUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Field Options
     * @param {string} deviceUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid: string, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getFieldOptionsProDevicesDeviceUuidOptionsDetailsGet(deviceUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the whole graphics configuration filtered by the preset.
     * @summary Get Graphics By Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {SportUuid2} [sportUuid] Sport UUID to filter the graphics configuration
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid: string, fieldUuid: string, presetUuid: string, sportUuid?: SportUuid2, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getGraphicsByPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGraphicsConfigurationGet(deviceUuid, fieldUuid, presetUuid, sportUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organizations Options
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getOrganizationsOptionsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidOrganizationsOptionsGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Preset Details
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid: string, fieldUuid: string, presetUuid: string, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getPresetDetailsProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidGet(deviceUuid, fieldUuid, presetUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Presets
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid: string, fieldUuid: string, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).getPresetsProDevicesDeviceUuidFieldsFieldUuidPresetsGet(deviceUuid, fieldUuid, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Device Config
     * @param {string} deviceUuid 
     * @param {EditDeviceDetailsDTO} editDeviceDetailsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public setDeviceConfigProDevicesDeviceUuidPut(deviceUuid: string, editDeviceDetailsDTO: EditDeviceDetailsDTO, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).setDeviceConfigProDevicesDeviceUuidPut(deviceUuid, editDeviceDetailsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Field Configuration
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {SetFieldConfig} setFieldConfig 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid: string, fieldUuid: string, setFieldConfig: SetFieldConfig, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).setFieldConfigurationProDevicesDeviceUuidFieldsFieldUuidPost(deviceUuid, fieldUuid, setFieldConfig, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Transfer Preset
     * @param {string} deviceUuid 
     * @param {string} fieldUuid 
     * @param {string} presetUuid 
     * @param {TransferPresetWithDTO} transferPresetWithDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProBroadcastApi
     */
    public transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid: string, fieldUuid: string, presetUuid: string, transferPresetWithDTO: TransferPresetWithDTO, options?: AxiosRequestConfig) {
        return ProBroadcastApiFp(this.configuration).transferPresetProDevicesDeviceUuidFieldsFieldUuidPresetsPresetUuidTransferPatch(deviceUuid, fieldUuid, presetUuid, transferPresetWithDTO, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SoftwaresApi - axios parameter creator
 * @export
 */
export const SoftwaresApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Deploy Software
         * @param {SoftwareNameEnum} software 
         * @param {DeployActionEnum} action 
         * @param {DeviceUUIDsDTO} deviceUUIDsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deploySoftwareSoftwaresSoftwareDeployPost: async (software: SoftwareNameEnum, action: DeployActionEnum, deviceUUIDsDTO: DeviceUUIDsDTO, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'software' is not null or undefined
            assertParamExists('deploySoftwareSoftwaresSoftwareDeployPost', 'software', software)
            // verify required parameter 'action' is not null or undefined
            assertParamExists('deploySoftwareSoftwaresSoftwareDeployPost', 'action', action)
            // verify required parameter 'deviceUUIDsDTO' is not null or undefined
            assertParamExists('deploySoftwareSoftwaresSoftwareDeployPost', 'deviceUUIDsDTO', deviceUUIDsDTO)
            const localVarPath = `/softwares/{software}/deploy`
                .replace(`{${"software"}}`, encodeURIComponent(String(software)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)

            if (action !== undefined) {
                localVarQueryParameter['action'] = action;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(deviceUUIDsDTO, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Software
         * @param {SoftwareNameEnum} software 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareSoftwaresSoftwareGet: async (software: SoftwareNameEnum, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'software' is not null or undefined
            assertParamExists('getSoftwareSoftwaresSoftwareGet', 'software', software)
            const localVarPath = `/softwares/{software}/`
                .replace(`{${"software"}}`, encodeURIComponent(String(software)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SoftwaresApi - functional programming interface
 * @export
 */
export const SoftwaresApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SoftwaresApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Deploy Software
         * @param {SoftwareNameEnum} software 
         * @param {DeployActionEnum} action 
         * @param {DeviceUUIDsDTO} deviceUUIDsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deploySoftwareSoftwaresSoftwareDeployPost(software: SoftwareNameEnum, action: DeployActionEnum, deviceUUIDsDTO: DeviceUUIDsDTO, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DeviceDeploymentDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deploySoftwareSoftwaresSoftwareDeployPost(software, action, deviceUUIDsDTO, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get Software
         * @param {SoftwareNameEnum} software 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSoftwareSoftwaresSoftwareGet(software: SoftwareNameEnum, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SoftwareAvailableDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSoftwareSoftwaresSoftwareGet(software, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SoftwaresApi - factory interface
 * @export
 */
export const SoftwaresApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SoftwaresApiFp(configuration)
    return {
        /**
         * 
         * @summary Deploy Software
         * @param {SoftwareNameEnum} software 
         * @param {DeployActionEnum} action 
         * @param {DeviceUUIDsDTO} deviceUUIDsDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deploySoftwareSoftwaresSoftwareDeployPost(software: SoftwareNameEnum, action: DeployActionEnum, deviceUUIDsDTO: DeviceUUIDsDTO, options?: any): AxiosPromise<Array<DeviceDeploymentDTO>> {
            return localVarFp.deploySoftwareSoftwaresSoftwareDeployPost(software, action, deviceUUIDsDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Software
         * @param {SoftwareNameEnum} software 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSoftwareSoftwaresSoftwareGet(software: SoftwareNameEnum, options?: any): AxiosPromise<SoftwareAvailableDTO> {
            return localVarFp.getSoftwareSoftwaresSoftwareGet(software, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SoftwaresApi - object-oriented interface
 * @export
 * @class SoftwaresApi
 * @extends {BaseAPI}
 */
export class SoftwaresApi extends BaseAPI {
    /**
     * 
     * @summary Deploy Software
     * @param {SoftwareNameEnum} software 
     * @param {DeployActionEnum} action 
     * @param {DeviceUUIDsDTO} deviceUUIDsDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public deploySoftwareSoftwaresSoftwareDeployPost(software: SoftwareNameEnum, action: DeployActionEnum, deviceUUIDsDTO: DeviceUUIDsDTO, options?: AxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).deploySoftwareSoftwaresSoftwareDeployPost(software, action, deviceUUIDsDTO, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Software
     * @param {SoftwareNameEnum} software 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SoftwaresApi
     */
    public getSoftwareSoftwaresSoftwareGet(software: SoftwareNameEnum, options?: AxiosRequestConfig) {
        return SoftwaresApiFp(this.configuration).getSoftwareSoftwaresSoftwareGet(software, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary User Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMeUsersMeGet: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users/me/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuthTokenWithCookies required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuthTokenWithCookies", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary User Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userMeUsersMeGet(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userMeUsersMeGet(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary User Me
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userMeUsersMeGet(options?: any): AxiosPromise<UserDTO> {
            return localVarFp.userMeUsersMeGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary User Me
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public userMeUsersMeGet(options?: AxiosRequestConfig) {
        return UsersApiFp(this.configuration).userMeUsersMeGet(options).then((request) => request(this.axios, this.basePath));
    }
}


